(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-reputation-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root._homepageMotifDestroy || !window.ShoptimizerStarfield) return;
    var canvas = root.querySelector('[data-homepage-canvas]');
    if (!canvas) return;
    var zone = root.querySelector('[data-homepage-motif-zone]');
    var controller = new AbortController();
    var cleanups = [];
    var lifecycle = {
      signal: controller.signal,
      listen: function (target, type, listener, options) {
        target.addEventListener(type, listener, Object.assign({}, options, {signal: controller.signal}));
      },
      cleanup: function (callback) { cleanups.push(callback); }
    };
    root._homepageMotifDestroy = function () {
      controller.abort();
      cleanups.forEach(function (callback) { callback(); });
      delete root._homepageMotifDestroy;
    };
    function placeCanvas() {
      var parent = window.innerWidth < 900 ? zone : root;
      if (canvas.parentElement !== parent) parent.insertBefore(canvas, parent.firstChild);
    }
    placeCanvas();
    lifecycle.listen(window, 'resize', placeCanvas);
    window.ShoptimizerStarfield.init(canvas, 'star', lifecycle, zone);
  }
  function boot() {
    document.querySelectorAll('[data-homepage-starfield]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shoptimizer:starfield:ready', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-homepage-starfield]').forEach(function (root) {
      if (root._homepageMotifDestroy) root._homepageMotifDestroy();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insights-benchmark-demo"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (typeof window.matchMedia !== "function") return;
  var mobile = window.matchMedia("(max-width: 750px)");

  function orderCards(scope) {
    scope.querySelectorAll("[data-oi-benchmark]").forEach(function (root) {
      var cards = root.querySelector(".oi-bm-hero");
      var table = root.querySelector("[data-oi-bm-table]");
      var comparison = table && table.closest(".oi-bm-card");
      if (!cards || !comparison) return;
      var trial = root.querySelector("[data-oi-bm-trial]");
      var anchor = mobile.matches && trial ? trial : comparison;
      if (mobile.matches ? anchor.nextElementSibling === cards : comparison.previousElementSibling === cards) return;
      var focused = cards.contains(document.activeElement) ? document.activeElement : null;
      anchor.parentNode.insertBefore(cards, mobile.matches ? anchor.nextSibling : comparison);
      if (focused) focused.focus({preventScroll: true});
    });
  }

  function updateLayout() { orderCards(document); }
  if (document.readyState !== "loading") updateLayout();
  else document.addEventListener("DOMContentLoaded", updateLayout, {once: true});
  mobile.addEventListener("change", updateLayout);
  document.addEventListener("shopify:section:load", function (event) {
    orderCards(event.target || document);
  });
})();

(function () {
  function requestHeaders(root) {
    var timer;
    var expired = false;
    var operation = Promise.resolve().then(function () {
      if (window.ShoptimizerAppCheck) return;
      if (!root.dataset.appCheckHelperUrl) throw new Error("app_check_configuration");
      return import(root.dataset.appCheckHelperUrl);
    }).then(function () {
      if (expired) throw new Error("app_check_timeout");
      return window.ShoptimizerAppCheck.getHeadersFromElement(root);
    });
    return Promise.race([operation, new Promise(function (_resolve, reject) {
      timer = setTimeout(function () { expired = true; reject(new Error("app_check_timeout")); }, 30000);
    })]).finally(function () { clearTimeout(timer); });
  }

  // Konfiguration kommt ausschließlich über data-* Attribute am Markup --
  // Der JavaScript-Block sieht kein Liquid.

  function ensureLeaflet(url, cb) {
    if (window.L) { cb(true); return; }
    var existing = document.getElementById("oi-bm-leaflet-js");
    if (existing) {
      if (existing.dataset.failed === "true") { cb(false); return; }
      existing.addEventListener("load", function () { cb(true); });
      existing.addEventListener("error", function () { cb(false); });
      return;
    }
    var s = document.createElement("script");
    s.id = "oi-bm-leaflet-js";
    s.src = url;
    s.crossOrigin = "";
    s.addEventListener("load", function () { cb(true); });
    s.addEventListener("error", function () { s.dataset.failed = "true"; cb(false); });
    document.head.appendChild(s);
  }

  function escapeHtml(str) {
    return String(str == null ? "" : str).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function hasMapCoordinates(lat, lng) {
    return typeof lat === "number" && Number.isFinite(lat) && Math.abs(lat) <= 90 &&
      typeof lng === "number" && Number.isFinite(lng) && Math.abs(lng) <= 180;
  }

  function mapRank(value) {
    return Number.isInteger(value) && value > 0 ? String(value) : "—";
  }

  function mapPinPositions(points, size, obstacles, gridOnly) {
    var occupied = obstacles.slice();
    var crowded = false;
    var positions = points.map(function (point) {
      if (size.x > 480 || point.x < 0 || point.x > size.x || point.y < 0 || point.y > size.y) return point;
      var minX = point.halfWidth + 8;
      var maxX = size.x - point.halfWidth - 8;
      var maxY = size.y - point.bottom - 8;
      var best = null;
      var bestDistance = Infinity;
      function consider(x, y) {
        var box = {left: x - point.halfWidth, right: x + point.halfWidth, top: y - 22, bottom: y + point.bottom};
        if (occupied.some(function (other) {
          return box.left < other.right + 4 && box.right > other.left - 4 &&
            box.top < other.bottom + 4 && box.bottom > other.top - 4;
        })) return;
        var distance = Math.pow(x - point.x, 2) + Math.pow(y - point.y, 2);
        if (distance < bestDistance) { best = {x: x, y: y, box: box}; bestDistance = distance; }
      }
      if (maxX >= minX && maxY >= 30) {
        if (!gridOnly) consider(Math.max(minX, Math.min(maxX, point.x)), Math.max(30, Math.min(maxY, point.y)));
        if (bestDistance !== 0) {
          for (var y = 30; y <= maxY; y += gridOnly ? 48 : 6) {
            for (var x = gridOnly ? 30 : minX; x <= maxX; x += gridOnly ? 48 : 6) {
              if (x >= minX) consider(x, y);
            }
          }
        }
      }
      if (!best) { crowded = true; return point; }
      occupied.push(best.box);
      return best;
    });
    return crowded && !gridOnly ? mapPinPositions(points, size, obstacles, true) : positions;
  }

  function initMap(el) {
    if (!el || el.closest(".is-failed, .is-loading") || el.dataset.oiInit === "1" || !window.L) return;
    var locs;
    try {
      locs = JSON.parse(el.dataset.locations || "[]");
    } catch (e) {
      locs = [];
    }
    var withCoords = locs.filter(function (l) {
      return l.visibility !== "locked" && hasMapCoordinates(l.lat, l.lng);
    });
    var card = el.closest("[data-oi-bm-map-card]");
    var details = card && card.querySelector("[data-oi-bm-map-details]");
    if (!withCoords.length) {
      el.innerHTML = '<p class="oi-bm-map-empty">' + escapeHtml(el.dataset.emptyLabel) + '</p>';
      if (details) { details.textContent = ""; details.hidden = true; }
      el.dataset.oiInit = "1";
      return;
    }
    el.dataset.oiInit = "1";

    var root = el.closest("[data-oi-benchmark]");
    var reviewsLabel = el.dataset.reviewsLabel == null ? reportCopy(root).reviews : el.dataset.reviewsLabel;
    var selected = withCoords.find(function (l) { return l.isSelf === true; }) || withCoords[0];
    var markers = [];
    var mapPadding = {paddingTopLeft: [48, 32], paddingBottomRight: [48, 72], animate: false};

    function locationRole(l) {
      return l.isSelf === true ? el.dataset.selfLabel : el.dataset.locationLabel;
    }

    function locationStats(l) {
      var rating = l.rating == null || l.rating === "" ? "—" : "★ " + l.rating;
      var reviews = l.reviews == null || l.reviews === "" ? "—" : l.reviews;
      return el.dataset.googleLabel + ": " + rating + " · " + reviews + " " + reviewsLabel;
    }

    function selectLocation(l) {
      if (details) {
        details.classList.toggle("is-self", l.isSelf === true);
        details.innerHTML = '<div class="oi-bm-map-details-rank">' + escapeHtml(el.dataset.rankLabel) +
          '<strong>' + escapeHtml(mapRank(l.rank)) + '</strong></div>' +
          '<span class="oi-bm-business-photo" data-oi-bm-map-photo hidden></span><div class="oi-bm-map-details-main">' +
          '<span class="oi-bm-map-role">' + escapeHtml(locationRole(l)) + '</span>' +
          '<strong class="oi-bm-map-name">' + escapeHtml(l.name || el.dataset.locationLabel) + '</strong>' +
          '<span class="oi-bm-map-stats">' + escapeHtml(locationStats(l)) + '</span>' +
          (l.url ? '<a href="' + escapeHtml(l.url) + '" class="oi-bm-map-link">' + escapeHtml(el.dataset.reportLabel) + ' ↗</a>' : '') + '</div>';
        renderBusinessPhoto(details.querySelector("[data-oi-bm-map-photo]"), l.isSelf === true ? l : null);
        details.hidden = false;
      }
      markers.forEach(function (item) {
        var icon = item.marker.getElement();
        icon.classList.toggle("is-selected", item.location === l);
        icon.setAttribute("aria-pressed", String(item.location === l));
      });
    }

    var map = L.map(el, { scrollWheelZoom: false }).setView([withCoords[0].lat, withCoords[0].lng], 12);
    L.tileLayer(el.dataset.tileUrl || "https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 19
    }).addTo(map);

    var bounds = [];
    withCoords.forEach(function (l) {
      var marker = L.marker([l.lat, l.lng], {
        keyboard: true,
        autoPanOnFocus: false,
        zIndexOffset: l.isSelf === true ? 1000 : 0,
        icon: L.divIcon({
          className: "oi-bm-map-pin" + (l.isSelf === true ? " is-self" : ""),
          iconSize: [44, 44],
          iconAnchor: [22, 22],
          html: '<span class="oi-bm-map-pin-rank" aria-hidden="true">' + escapeHtml(mapRank(l.rank)) + '</span>' +
            (l.isSelf === true ? '<span class="oi-bm-map-pin-self" aria-hidden="true">' + escapeHtml(el.dataset.selfLabel) + '</span>' : '')
        })
      }).addTo(map);
      var icon = marker.getElement();
      icon.setAttribute("aria-label", locationRole(l) + ": " + (l.name || el.dataset.locationLabel) + ", " +
        el.dataset.rankLabel + " " + mapRank(l.rank) + ". " + locationStats(l));
      if (details) icon.setAttribute("aria-controls", details.id);
      marker.on("click", function () { selectLocation(l); });
      icon.addEventListener("focus", function () { map.panInside(marker.getLatLng(), mapPadding); });
      icon.addEventListener("keydown", function (event) {
        if (event.key === " " || event.key === "Enter") {
          event.preventDefault();
          event.stopPropagation();
          selectLocation(l);
        }
      });
      markers.push({marker: marker, location: l, leader: L.polyline([], {
        className: "oi-bm-map-leader", weight: 1.5, opacity: 0.75, interactive: false
      }).addTo(map)});
      bounds.push([l.lat, l.lng]);
    });
    selectLocation(selected);

    function arrangeMapPins() {
      var rect = el.getBoundingClientRect();
      var obstacles = Array.from(el.querySelectorAll(".leaflet-control")).map(function (control) {
        var box = control.getBoundingClientRect();
        return {left: box.left - rect.left, right: box.right - rect.left, top: box.top - rect.top, bottom: box.bottom - rect.top};
      });
      var ordered = markers.slice().sort(function (a, b) {
        return Number(b.location.isSelf === true) - Number(a.location.isSelf === true);
      });
      var points = ordered.map(function (item) {
        var point = map.latLngToContainerPoint([item.location.lat, item.location.lng]);
        var label = item.marker.getElement().querySelector(".oi-bm-map-pin-self");
        return {x: point.x, y: point.y, halfWidth: label ? Math.max(22, label.offsetWidth / 2) : 22,
          bottom: 22 + (label ? label.offsetHeight : 0)};
      });
      mapPinPositions(points, map.getSize(), obstacles).forEach(function (point, i) {
        var item = ordered[i];
        var original = [item.location.lat, item.location.lng];
        var shifted = Math.abs(point.x - points[i].x) > 1 || Math.abs(point.y - points[i].y) > 1;
        var position = shifted ? map.containerPointToLatLng([point.x, point.y]) : original;
        item.marker.setLatLng(position);
        item.leader.setLatLngs(shifted ? [original, position] : []);
      });
    }

    var measuredSize = "";
    function refreshMapSize() {
      var size = el.getBoundingClientRect();
      var key = size.width + ":" + size.height;
      if (!size.width || !size.height || key === measuredSize) return;
      measuredSize = key;
      map.invalidateSize({pan: false});
      if (bounds.length > 1) map.fitBounds(bounds, mapPadding);
      arrangeMapPins();
    }
    map.on("moveend", arrangeMapPins);
    var initialSizeTimer = setTimeout(refreshMapSize, 0);
    var sizeObserver = new ResizeObserver(refreshMapSize);
    sizeObserver.observe(el);
    el.oiMapCleanup = function () {
      clearTimeout(initialSizeTimer);
      sizeObserver.disconnect();
      map.remove();
    };
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var maps = scope.querySelectorAll("[data-oi-map]");
    if (!maps.length) return;
    ensureLeaflet(maps[0].dataset.leafletUrl, function (loaded) {
      maps.forEach(function (el) {
        if (loaded) initMap(el);
        else el.textContent = reportCopy(el.closest("[data-oi-benchmark]")).map_error;
      });
    });
  }

  // --- Live-Daten aus /api/analysis/:slug (Benchmark-Reports) --------------

  function textOf(node, value) {
    if (node) node.textContent = value == null ? "" : String(value);
  }

  function clearNode(node) {
    if (node) node.textContent = "";
  }

  function renderBusinessPhoto(host, entry) {
    if (!host) return;
    clearNode(host);
    host.hidden = true;
    if (!entry || entry.visibility === "locked" || !entry.photo) return;
    var photo;
    try {
      photo = new URL(entry.photo);
      if (photo.protocol !== "http:" && photo.protocol !== "https:") return;
    } catch (err) { return; }
    var img = document.createElement("img");
    img.alt = "";
    img.width = 112;
    img.height = 112;
    img.decoding = "async";
    img.addEventListener("load", function () {
      if (img.parentNode === host) host.hidden = false;
    });
    img.addEventListener("error", function () {
      if (img.parentNode === host) { host.hidden = true; clearNode(host); }
    });
    host.appendChild(img);
    img.src = photo.href;
  }

  // Structural UI comes from Liquid; provider review text remains in its source language.
  function reportCopy(root) {
    return root.oiReportCopy || (root.oiReportCopy = JSON.parse(root.dataset.reportI18n || "{}"));
  }

  function formatNumber(value, root, digits) {
    if (value == null || value === "" || !isFinite(Number(value))) return "—";
    return Number(value).toLocaleString(root.dataset.locale, digits == null ? {} : {
      minimumFractionDigits: digits, maximumFractionDigits: digits
    });
  }

  function formatPercent(value, root) {
    return value == null || value === "" || !isFinite(Number(value)) ? "—" :
      (Number(value) / 100).toLocaleString(root.dataset.locale, {style: "percent", maximumFractionDigits: 2});
  }

  function localPageUrl(value, root) {
    if (!value) return value;
    try {
      var url = new URL(value, window.location.href);
      var prefix = (root.dataset.rootUrl || "/").replace(/\/$/, "");
      if (url.origin === new URL(window.location.href).origin && prefix &&
          (url.pathname === "/" || url.pathname.indexOf("/pages/") === 0)) {
        url.pathname = prefix + url.pathname;
        return url.pathname + url.search + url.hash;
      }
    } catch (err) { /* Preserve the merchant's link if it cannot be parsed. */ }
    return value;
  }

  function formatDate(iso, root) {
    if (typeof iso !== "string" || !iso) return "";
    try {
      var provider = /^(\d{1,2})\/(\d{1,2})\/(\d{4})(?: \d{2}:\d{2}:\d{2})?$/.exec(iso);
      if (provider) {
        var month = Number(provider[1]), day = Number(provider[2]), year = Number(provider[3]);
        var calendar = new Date(Date.UTC(year, month - 1, day));
        if (calendar.getUTCFullYear() !== year || calendar.getUTCMonth() !== month - 1 || calendar.getUTCDate() !== day) return "";
        return calendar.toLocaleDateString(root.dataset.locale, {day: "2-digit", month: "2-digit", year: "numeric", timeZone: "UTC"});
      }
      var date = new Date(iso);
      if (!isFinite(date.getTime())) return "";
      return date.toLocaleDateString(root.dataset.locale, { day: "2-digit", month: "2-digit", year: "numeric" });
    } catch (err) {
      return "";
    }
  }

  function analysisDateNote(entry, root) {
    if (entry.depth === "basic") return "";
    var date = formatDate(entry.analysisCreatedAt, root);
    return date ? fillTemplate(reportCopy(root).analysis_date, {datum: date}) : reportCopy(root).analysis_date_missing;
  }

  function capitalizeQuery(str) {
    var v = String(str == null ? "" : str);
    return v ? v.charAt(0).toUpperCase() + v.slice(1) : v;
  }

  function starRow(rating) {
    var r = Math.round(Number(rating) || 0);
    if (r < 0) r = 0;
    if (r > 5) r = 5;
    return new Array(r + 1).join("★") + new Array(6 - r).join("☆");
  }

  function initialsOf(name) {
    var words = String(name || "").trim().split(/\s+/).filter(Boolean);
    if (!words.length) return "?";
    return ((words[0][0] || "") + (words.length > 1 ? words[1][0] : "")).toUpperCase();
  }

  function fillTemplate(tpl, values) {
    return String(tpl || "").replace(/\[(n|gefunden|analysiert|datum|namen|q|answered)\]/g, function (_m, key) {
      return values[key] == null ? "" : String(values[key]);
    });
  }

  function fixed(value, digits, root) {
    return formatNumber(value, root, digits);
  }

  function benchmarkUrlWithParam(url, key, value) {
    var hashAt = url.indexOf("#");
    var hash = hashAt === -1 ? "" : url.slice(hashAt);
    var beforeHash = hashAt === -1 ? url : url.slice(0, hashAt);
    return beforeHash + (beforeHash.indexOf("?") !== -1 ? "&" : "?") +
      encodeURIComponent(key) + "=" + encodeURIComponent(value) + hash;
  }

  /** Baut eine Zeile der Rangliste im bestehenden Markup-Schema. */
  function buildRankRow(root, entry, index) {
    var param = (root.dataset.slugParam || "slug").trim() || "slug";
    var target = (root.dataset.reportUrl || "").trim();
    var locked = entry.visibility === "locked";
    var hasReport = !locked && target && entry.slug && entry.depth !== "basic";
    var row = document.createElement("div");
    row.setAttribute("role", "row");
    row.className = "oi-bm-row" + (hasReport ? " is-linked" : "") + (locked ? " is-locked" : "") + (entry.isSelf ? " is-self" : "");

    var pos = document.createElement("span");
    var rank = root.dataset.reportMode === "competitors" ? entry.overallRank : index + 1;
    pos.className = "oi-bm-pos" + (rank && rank <= 3 ? " is-" + rank : "");
    pos.textContent = formatNumber(rank, root);

    var thumb = document.createElement("span");
    thumb.className = "oi-bm-thumb";
    var avatar = document.createElement("span");
    avatar.className = "oi-bm-avatar";
    avatar.setAttribute("aria-hidden", "true");
    avatar.textContent = locked ? "" : initialsOf(entry.name);
    if (!locked && entry.photo) {
      var img = document.createElement("img");
      img.className = "oi-bm-thumb-img";
      img.src = entry.photo;
      img.alt = entry.name || "";
      img.loading = "lazy";
      avatar.style.display = "none";
      img.addEventListener("error", function () {
        img.style.display = "none";
        avatar.style.display = "flex";
      });
      thumb.appendChild(img);
    }
    thumb.appendChild(avatar);

    var name = document.createElement("span");
    name.className = "oi-bm-name";
    if (locked) {
      var placeholder = document.createElement("span");
      placeholder.className = "oi-bm-identity-blur";
      placeholder.setAttribute("aria-hidden", "true");
      placeholder.textContent = reportCopy(root).nearby_competitor;
      name.appendChild(placeholder);
      name.appendChild(document.createTextNode(reportCopy(root).identity_hidden));
    } else {
      if (hasReport) {
        var link = document.createElement("a");
        link.className = "oi-bm-location-link";
        link.href = benchmarkUrlWithParam(target, param, entry.slug);
        if (root.dataset.returnTo) link.href = benchmarkUrlWithParam(link.href, "returnTo", root.dataset.returnTo);
        link.textContent = entry.name || reportCopy(root).map_location;
        name.appendChild(link);
      } else {
        name.appendChild(document.createTextNode(entry.name || reportCopy(root).map_location));
      }
      if (entry.isSelf) {
        var selfLabel = document.createElement("span");
        selfLabel.className = "oi-bm-self-label";
        selfLabel.textContent = reportCopy(root).map_self;
        name.appendChild(selfLabel);
      }
    }
    if (!locked && entry.city) {
      var city = document.createElement("span");
      city.className = "oi-bm-city";
      city.textContent = entry.city;
      name.appendChild(city);
    }

    if (root.dataset.reportMode === "competitors") {
      var mobileReviews = document.createElement("span");
      mobileReviews.className = "oi-bm-mobile-reviews";
      mobileReviews.textContent = (Number(entry.reviewsCount) === 1 ? reportCopy(root).review_count_one : fillTemplate(reportCopy(root).review_count, {n: formatNumber(entry.reviewsCount, root)}));
      name.appendChild(mobileReviews);
    }
    if (entry.depth || root.dataset.reportMode === "benchmark") {
      var depth = document.createElement("span");
      depth.className = "oi-bm-depth";
      depth.textContent = entry.depth === "basic" ? reportCopy(root).basic_comparison : analysisDateNote(entry, root);
      name.appendChild(depth);
    }

    var bayes = document.createElement("span");
    bayes.className = "oi-bm-bayes";
    bayes.textContent = fixed(entry.bayesRating, 2, root);

    var google = document.createElement("span");
    google.className = "oi-bm-google";
    if (entry.googleRating != null) {
      var star = document.createElement("span");
      star.className = "oi-bm-star";
      star.textContent = "★";
      google.appendChild(star);
      google.appendChild(document.createTextNode(" " + formatNumber(entry.googleRating, root, 1)));
    } else {
      google.textContent = "—";
    }

    var reviews = document.createElement("span");
    reviews.className = "oi-bm-reviews";
    reviews.textContent = formatNumber(entry.reviewsCount, root);

    var resp = document.createElement("span");
    resp.className = "oi-bm-resp";
    resp.textContent = formatPercent(entry.responseRate, root);
    resp.title = responseNote(entry, root);

    [pos, thumb, name, bayes, google, reviews, resp].forEach(function (node) {
      node.setAttribute("role", "cell");
      row.appendChild(node);
    });
    return row;
  }

  function responseNote(entry, root) {
    var copy = reportCopy(root);
    if (entry.responseRate == null) return copy.response_unavailable + " " + copy.response_not_total;
    var sample = entry.responseSample || {};
    var note = sample.answered == null ? copy.response_sample :
      fillTemplate(copy.response_answered, {answered: formatNumber(sample.answered, root), n: formatNumber(sample.count, root)});
    if (sample.from && sample.to) note += " " + formatDate(sample.from, root) + "–" + formatDate(sample.to, root) + ".";
    return note + " " + copy.response_not_total;
  }

  function renderChips(host, items, modifier, emptyText, root) {
    if (!host) return;
    clearNode(host);
    if (!items || !items.length) {
      var empty = document.createElement("span");
      empty.className = "oi-bm-chip " + modifier;
      empty.textContent = emptyText;
      host.appendChild(empty);
      return;
    }
    items.forEach(function (k) {
      var chip = document.createElement("span");
      chip.className = "oi-bm-chip " + modifier;
      chip.textContent = k.word + " · " + formatNumber(k.count, root);
      host.appendChild(chip);
    });
  }

  /**
   * Zitat im Benchmark. Der Autorenname bleibt bewusst außen vor — die API
   * liefert ihn aus Datenschutzgründen nicht.
   */
  function renderQuote(host, quote, worst, emptyText, root) {
    if (!host) return;
    clearNode(host);
    var wrap = document.createElement("div");
    wrap.className = worst ? "oi-bm-quote worst" : "oi-bm-quote";
    var p = document.createElement("p");
    if (!quote || !quote.text) {
      p.textContent = emptyText;
      wrap.appendChild(p);
      host.appendChild(wrap);
      return;
    }
    p.textContent = "„" + quote.text + "\u201C";
    wrap.appendChild(p);

    var meta = document.createElement("div");
    meta.className = "oi-bm-quote-meta";
    var stars = document.createElement("span");
    stars.className = "oi-bm-quote-stars";
    stars.setAttribute("aria-hidden", "true");
    stars.textContent = starRow(quote.rating);
    meta.appendChild(stars);
    [quote.locationName, formatDate(quote.date, root)].forEach(function (part) {
      if (part) meta.appendChild(document.createTextNode(" · " + part));
    });
    wrap.appendChild(meta);
    host.appendChild(wrap);
  }

  function applyBenchmark(root, data) {
    root.dataset.reportMode = data.mode === "competitors" ? "competitors" : "benchmark";
    var comparisonNotice = root.querySelector("[data-oi-bm-comparison-notice]");
    if (comparisonNotice) {
      var notice = data.comparison && typeof data.comparison.notice === "string" ? data.comparison.notice.trim() : "";
      if (notice === "Auswahl passender Kategorieangaben im lokalen Umkreis; gezeigt werden Rangnachbarn oberhalb und unterhalb Ihres Betriebs. Kategorieangaben und Bewertungszahlen belegen kein gleiches Geschäftsmodell oder gleiche Betriebsgröße; Konzept und Zielgruppe können abweichen. Keine vollständige Marktübersicht.") notice = root.dataset.comparisonShort || notice;
      comparisonNotice.textContent = notice;
      comparisonNotice.hidden = !notice;
    }
    var aggregate = data.aggregate || {};
    var ranking = data.ranking || [];
    renderBusinessPhoto(root.querySelector("[data-oi-bm-photo]"), data.mode === "competitors" ?
      ranking.find(function (entry) { return entry.isSelf; }) : null);
    var topicAnalysis = data.topicAnalysis || {};
    var topicsAvailable = topicAnalysis.version === 1 && topicAnalysis.method === "aspect_mentions" && topicAnalysis.status === "available";
    var keywords = topicsAvailable ? data.keywords || {} : {};
    var quotes = data.quotes || {};

    textOf(root.querySelector("[data-oi-bm-avg-label]"), root.dataset.avgRatingLabel);
    textOf(root.querySelector("[data-oi-bm-bayes-label]"), root.dataset.bayesLabel);
    textOf(root.querySelector("[data-oi-bm-total-label]"), root.dataset.totalReviewsLabel);
    textOf(root.querySelector("[data-oi-bm-resp-label]"), root.dataset.responseLabel);
    var dateNode = root.querySelector("[data-oi-bm-date]");
    var analysisDate = formatDate(data.createdAt, root);
    textOf(dateNode, analysisDate ? fillTemplate(root.dataset.datePattern, { datum: analysisDate }) : "");
    if (dateNode) dateNode.hidden = !dateNode.textContent;
    textOf(root.querySelector("[data-oi-bm-badge]"),
      fillTemplate(root.dataset.badgePattern, { n: data.locationsAnalyzed == null ? "" : formatNumber(data.locationsAnalyzed, root) }));
    textOf(root.querySelector("[data-oi-bm-heading]"), capitalizeQuery(data.query || ""));
    textOf(root.querySelector("[data-oi-bm-locmeta]"), fillTemplate(root.dataset.metaPattern, {
      gefunden: data.locationsFound == null ? "" : formatNumber(data.locationsFound, root),
      analysiert: data.locationsAnalyzed == null ? "" : formatNumber(data.locationsAnalyzed, root)
    }));

    var skippedEl = root.querySelector("[data-oi-bm-skipped]");
    if (skippedEl) {
      var notes = [];
      if (data.mode !== "competitors" && data.skipped && data.skipped.length) {
        notes.push(fillTemplate(root.dataset.skippedPattern, {
          n: data.skipped.length == null ? "" : formatNumber(data.skipped.length, root),
          namen: data.skipped.map(function (x) { return x.name; }).join(", ")
        }));
      }
      if (data.stragglersRemaining) {
        notes.push(fillTemplate(root.dataset.stragglerPattern, { n: data.stragglersRemaining == null ? "" : formatNumber(data.stragglersRemaining, root) }));
      }
      skippedEl.textContent = "";
      notes.forEach(function (note, i) {
        if (i > 0) { skippedEl.appendChild(document.createElement("br")); }
        skippedEl.appendChild(document.createTextNode(note));
      });
      skippedEl.hidden = !notes.length;
    }

    textOf(root.querySelector("[data-oi-bm-avg]"), fixed(aggregate.avgRating, 1, root));
    var avgStars = root.querySelector("[data-oi-bm-avgstars]");
    if (avgStars) {
      clearNode(avgStars);
      var wrap = document.createElement("span");
      wrap.className = "oi-bm-starwrap";
      wrap.setAttribute("role", "img");
      wrap.setAttribute("aria-label", reportCopy(root).average + " " + fixed(aggregate.avgRating, 1, root) + " " + reportCopy(root).out_of_five);
      var inner = document.createElement("span");
      inner.setAttribute("aria-hidden", "true");
      inner.textContent = aggregate.avgRating == null ? "—" : starRow(aggregate.avgRating);
      wrap.appendChild(inner);
      avgStars.appendChild(wrap);
    }
    textOf(root.querySelector("[data-oi-bm-bayes]"), fixed(aggregate.bayesRating, 2, root));
    textOf(root.querySelector("[data-oi-bm-total]"), formatNumber(aggregate.totalReviews, root));
    textOf(root.querySelector("[data-oi-bm-resp]"), formatPercent(aggregate.avgResponseRate, root));
    textOf(root.querySelector("[data-oi-bm-response-note]"), aggregate.avgResponseRate == null ?
      reportCopy(root).response_data_unavailable : reportCopy(root).response_average);
    var responseScope = root.querySelector("[data-oi-bm-ranking-note]");
    textOf(responseScope, fillTemplate(reportCopy(root).ranking_shown, {n: formatNumber(ranking.length, root)}) + " " + reportCopy(root).response_scope);
    if (responseScope) responseScope.hidden = false;

    var title = root.querySelector("[data-oi-bm-ranking-title]");
    if (title) {
      var tip = title.querySelector(".oi-bm-tip");
      title.textContent = fillTemplate(root.dataset.rankingTitle, { n: ranking.length == null ? "" : formatNumber(ranking.length, root) });
      if (tip) title.appendChild(tip);
    }

    var table = root.querySelector("[data-oi-bm-table]");
    if (table) {
      var head = table.querySelector(".oi-bm-head");
      clearNode(table);
      if (head) table.appendChild(head);
      ranking.forEach(function (entry, i) { table.appendChild(buildRankRow(root, entry, i)); });
    }

    var topicNotice = typeof topicAnalysis.notice === "string" ? topicAnalysis.notice.trim() : "";
    var genericTopicNotice = !topicNotice || topicNotice === root.dataset.topicShort || topicNotice === root.dataset.topicNote || topicNotice === "Die Sterne beziehen sich auf die gesamte Rezension, nicht auf das einzelne Thema. Gezählt werden Nennungen bekannter Aspekte in Rezensionen mit 4–5 bzw. 1–2 Sternen; Rezensionen mit 3 Sternen sind nicht enthalten. Das ist keine Bewertung einzelner Aspekte.";
    var topicNote = root.querySelector("[data-oi-topic-note]");
    textOf(topicNote, topicsAvailable && genericTopicNotice ? "" : topicNotice || root.dataset.topicUnavailable);
    if (topicNote) topicNote.hidden = !topicNote.textContent;
    renderChips(root.querySelector("[data-oi-bm-chips-pos]"), keywords.positive, "pos",
      topicsAvailable ? root.dataset.topicEmptyPositive : root.dataset.topicEmptyUnavailable, root);
    renderChips(root.querySelector("[data-oi-bm-chips-neg]"), keywords.negative, "neg",
      topicsAvailable ? root.dataset.topicEmptyNegative : root.dataset.topicEmptyUnavailable, root);
    renderQuote(root.querySelector("[data-oi-bm-best]"), quotes.best, false,
      reportCopy(root).quote_empty, root);
    renderQuote(root.querySelector("[data-oi-bm-worst]"), quotes.worst, true,
      reportCopy(root).quote_critical_empty, root);

    if (data.mode === "competitors") applyCompetitors(root, data);
    else renderTrial(root, "benchmark");

    // Kartendaten aus der Rangliste aufbauen und Leaflet danach starten.
    var mapEl = root.querySelector("[data-oi-map]");
    var mapCard = root.querySelector("[data-oi-bm-map-card]");
    if (mapEl) {
      var param = (root.dataset.slugParam || "slug").trim() || "slug";
      var target = (root.dataset.reportUrl || "").trim();
      var hiddenCount = 0;
      var missingCount = 0;
      var points = ranking.reduce(function (locations, e, index) {
        if (e.visibility === "locked") { hiddenCount++; return locations; }
        if (!hasMapCoordinates(e.latitude, e.longitude)) { missingCount++; return locations; }
        var url = target && e.slug && e.depth !== "basic" ? benchmarkUrlWithParam(target, param, e.slug) : "";
        if (url && root.dataset.returnTo) url = benchmarkUrlWithParam(url, "returnTo", root.dataset.returnTo);
        locations.push({
          name: e.name || "",
          rating: e.googleRating == null ? "" : formatNumber(e.googleRating, root, 1),
          reviews: e.reviewsCount == null ? "" : formatNumber(e.reviewsCount, root),
          url: url,
          lat: e.latitude,
          lng: e.longitude,
          rank: root.dataset.reportMode === "competitors" ? e.overallRank : index + 1,
          isSelf: e.isSelf === true,
          photo: e.isSelf === true ? e.photo : ""
        });
        return locations;
      }, []);
      mapEl.dataset.locations = JSON.stringify(points);
      var mapTitle = root.querySelector("[data-oi-bm-map-title]");
      textOf(mapTitle, points.length === 1 && points[0].isSelf ? root.dataset.mapSelfTitle : root.dataset.mapTitle);
      if (mapTitle) mapEl.setAttribute("aria-label", mapTitle.textContent);
      var mapNotes = [];
      if (hiddenCount) mapNotes.push(fillTemplate(hiddenCount === 1 ? root.dataset.mapHiddenOne : root.dataset.mapHiddenMany, { n: hiddenCount == null ? "" : formatNumber(hiddenCount, root) }));
      if (missingCount) mapNotes.push(fillTemplate(missingCount === 1 ? root.dataset.mapMissingOne : root.dataset.mapMissingMany, { n: missingCount == null ? "" : formatNumber(missingCount, root) }));
      var mapNote = root.querySelector("[data-oi-bm-map-note]");
      textOf(mapNote, mapNotes.join(" "));
      if (mapNote) mapNote.hidden = !mapNotes.length;
      var mapContext = root.querySelector("[data-oi-bm-map-context]");
      if (mapContext) mapContext.hidden = root.dataset.reportMode !== "competitors";
      if (points.length) {
        if (mapCard) mapCard.hidden = false;
      } else if (mapCard) {
        mapCard.hidden = true;
      }
    }
  }

  function competitorText(pattern, benchmarkDefault, competitorDefault, values, localizedDefault) {
    var normalized = typeof pattern === "string" ? pattern.trim() : pattern;
    var defaultText = typeof benchmarkDefault === "string" ? benchmarkDefault.trim() : benchmarkDefault;
    var translatedDefault = typeof localizedDefault === "string" ? localizedDefault.trim() : localizedDefault;
    // Recognize the known German standard after a storefront-language switch; custom copy stays untouched.
    if (pattern == null || normalized === defaultText || normalized === translatedDefault ||
      (defaultText === "Top 10 Ranking (fairer Vergleichswert)" && normalized === "Ranking (geglätteter Vergleichswert)")) return competitorDefault;
    return values ? fillTemplate(pattern, values) : pattern;
  }

  function applyCompetitors(root, data) {
    var ranking = data.ranking;
    var self = ranking.find(function (entry) { return entry.isSelf; });
    if (!self) throw new Error("invalid_competitors");
    var center = data.center || {};
    var teaser = data.teaser || {};
    var variant = ["challenger", "leader", "solo"].indexOf(teaser.variant) >= 0 ? teaser.variant : "challenger";
    var rivals = ranking.length - 1;
    root.dataset.reportMode = "competitors";
    root.dataset.teaserVariant = variant;
    textOf(root.querySelector("[data-oi-bm-badge]"), competitorText(root.dataset.badgePattern,
      "Benchmark · [n] Standorte", (rivals === 1 ? reportCopy(root).competitor_badge_one : fillTemplate(reportCopy(root).competitor_badge, {n: formatNumber(rivals, root)})),
      { n: data.locationsAnalyzed == null ? "" : formatNumber(data.locationsAnalyzed, root) }, reportCopy(root).benchmark_badge));
    textOf(root.querySelector("[data-oi-bm-heading]"), center.name || self.name);
    var dateNode = root.querySelector("[data-oi-bm-date]");
    var analysisDate = formatDate(data.createdAt, root);
    textOf(dateNode, analysisDate ? competitorText(root.dataset.datePattern,
      "Benchmark analysiert am [datum]", fillTemplate(reportCopy(root).competitor_date, {datum: analysisDate}),
      { datum: analysisDate }, reportCopy(root).benchmark_date) : "");
    if (dateNode) dateNode.hidden = !dateNode.textContent;
    var meta = [center.city, data.branch && data.branch.label,
      data.radiusKm == null ? "" : fillTemplate(reportCopy(root).radius, {n: formatNumber(data.radiusKm, root)})].filter(Boolean);
    var discovered = data.locationsDiscovered;
    if (discovered != null) meta.push((Number(discovered) === 1 ? reportCopy(root).businesses_found_one : fillTemplate(reportCopy(root).businesses_found, {n: formatNumber(discovered, root)})));
    textOf(root.querySelector("[data-oi-bm-locmeta]"), competitorText(root.dataset.metaPattern,
      "[gefunden] Standorte gefunden · [analysiert] analysiert", meta.join(" · "), {
        gefunden: (data.locationsDiscovered == null ? data.locationsFound : data.locationsDiscovered) == null ? "" : formatNumber(data.locationsDiscovered == null ? data.locationsFound : data.locationsDiscovered, root),
        analysiert: data.locationsAnalyzed == null ? "" : formatNumber(data.locationsAnalyzed, root)
      }, reportCopy(root).benchmark_meta));

    var total = self.overallTotal;
    textOf(root.querySelector("[data-oi-bm-avg]"), self.overallRank && total ? formatNumber(self.overallRank, root) + " / " + formatNumber(total, root) : "—");
    textOf(root.querySelector("[data-oi-bm-avgstars]"), reportCopy(root).local_rank);
    textOf(root.querySelector("[data-oi-bm-avg-label]"), competitorText(root.dataset.avgRatingLabel,
      "Ø Google-Rating über alle Standorte", total ? (Number(total) === 1 ? reportCopy(root).rank_total_one : fillTemplate(reportCopy(root).rank_total, {n: formatNumber(total, root)})) : reportCopy(root).rank_unavailable, null, reportCopy(root).benchmark_avg_label));
    textOf(root.querySelector("[data-oi-bm-bayes]"), fixed(self.googleRating, 1, root));
    textOf(root.querySelector("[data-oi-bm-bayes-caption]"), self.googleRating == null ? "—" : starRow(self.googleRating));
    textOf(root.querySelector("[data-oi-bm-bayes-label]"), competitorText(root.dataset.bayesLabel,
      "Basis für die Rangliste", reportCopy(root).your_rating, null, reportCopy(root).benchmark_bayes_label));
    textOf(root.querySelector("[data-oi-bm-total]"), formatNumber(self.reviewsCount, root));
    textOf(root.querySelector("[data-oi-bm-total-label]"), competitorText(root.dataset.totalReviewsLabel,
      "Bewertungen gesamt", reportCopy(root).your_reviews, null, reportCopy(root).benchmark_total_label));
    textOf(root.querySelector("[data-oi-bm-resp]"), formatPercent(self.responseRate, root));
    textOf(root.querySelector("[data-oi-bm-resp-label]"), competitorText(root.dataset.responseLabel,
      "Ø Antwortquote · Stichproben", reportCopy(root).your_response, null, reportCopy(root).benchmark_response_label));
    var originalAnalysis = analysisDateNote(self, root);
    textOf(root.querySelector("[data-oi-bm-response-note]"), responseNote(self, root) + (originalAnalysis ? " " + originalAnalysis + "." : ""));
    var title = root.querySelector("[data-oi-bm-ranking-title]");
    if (title) {
      var tip = title.querySelector(".oi-bm-tip");
      title.textContent = competitorText(root.dataset.rankingTitle,
        "Top 10 Ranking (fairer Vergleichswert)", reportCopy(root).direct_comparison, { n: formatNumber(ranking.length, root) }, reportCopy(root).benchmark_ranking_title);
      if (tip) title.appendChild(tip);
    }
    var note = root.querySelector("[data-oi-bm-ranking-note]");
    var scope = fillTemplate(reportCopy(root).rank_scope, {n: formatNumber(ranking.length, root)});
    if (variant === "solo") scope = reportCopy(root).no_competitors;
    textOf(note, scope);
    if (note) note.hidden = false;
    var skipped = root.querySelector("[data-oi-bm-skipped]");
    var warnings = [];
    if (data.branch && data.branch.source === "fallback") warnings.push(reportCopy(root).branch_fallback);
    if (data.degraded) warnings.push(reportCopy(root).search_degraded);
    if (data.skipped && data.skipped.length) warnings.push(fillTemplate(reportCopy(root).analyses_incomplete, {n: formatNumber(data.skipped.length, root)}));
    if (!center.analyzed) warnings.push(reportCopy(root).own_analysis_unavailable);
    textOf(skipped, warnings.join(" "));
    if (skipped) skipped.hidden = !warnings.length;

    renderTrial(root, variant);
    var analysisNote = root.querySelector("[data-oi-bm-analysis-note]");
    textOf(analysisNote, data.locationsAnalyzed == null ? "" : fillTemplate(reportCopy(root).analysis_scope, {n: formatNumber(data.locationsAnalyzed, root)}));
    if (analysisNote) analysisNote.hidden = data.locationsAnalyzed == null;
  }

  function renderTrial(root, variant) {
    var trial = root.querySelector("[data-oi-bm-trial]");
    if (trial) trial.hidden = false;
    var key = variant.charAt(0).toUpperCase() + variant.slice(1);
    textOf(root.querySelector("[data-oi-bm-trial-title]"), root.dataset["trial" + key + "Title"]);
    textOf(root.querySelector("[data-oi-bm-trial-text]"), root.dataset["trial" + key + "Text"] || "");
  }

  function setBenchmarkStatus(root, message, state) {
    var status = root.querySelector("[data-oi-bm-status]");
    if (status) { textOf(status, message); status.hidden = !message; }
    root.classList.toggle("is-loading", state === "loading");
    root.classList.toggle("is-failed", state === "failed");
    root.setAttribute("aria-busy", state === "loading" ? "true" : "false");
  }

  function loadBenchmark(root, slug) {
    var base = (root.dataset.apiBase || "").trim().replace(/\/+$/, "");
    var controller = new AbortController();
    var timeout;
    setBenchmarkStatus(root, (root.dataset.loadingText == null ? reportCopy(root).benchmark_loading : root.dataset.loadingText), "loading");
    var handoff = window.OptimizzerReportHandoff?.take(base, slug);
    var reportRequest = Promise.resolve(handoff).then(function (data) {
      if (data) return data;
      return requestHeaders(root).then(function (headers) {
      if (controller.signal.aborted) throw new Error("request_aborted");
      timeout = setTimeout(function () { controller.abort(); }, 15000);
      return fetch(base + "/api/analysis/" + encodeURIComponent(slug) + "?view=1", { credentials: "omit", headers: headers, signal: controller.signal });
    })
      .then(function (res) {
        if (res.status === 404) throw new Error("not_found");
        if (res.status === 429 || res.status === 503) throw new Error("global_limit");
        if (!res.ok) throw new Error("http_" + res.status);
        return res.json();
      });
    });
    reportRequest.then(function (data) {
        if (!data || (data.kind !== "single" && data.kind !== "multi")) throw new Error("invalid_report");
        if (data.kind === "single") {
          var param = (root.dataset.slugParam || "slug").trim() || "slug";
          var target = (root.dataset.reportUrl || "").trim();
          if (target) {
            var redirect = benchmarkUrlWithParam(target, param, slug);
            if (root.dataset.returnTo) redirect = benchmarkUrlWithParam(redirect, "returnTo", root.dataset.returnTo);
            window.location.replace(redirect);
            return;
          }
          throw new Error("wrong_kind");
        }
        if (!Array.isArray(data.ranking) || !data.ranking.length || !data.aggregate) throw new Error("invalid_report");
        if (data.mode === "competitors" && !data.ranking.some(function (entry) { return entry.isSelf; })) throw new Error("invalid_report");
        applyBenchmark(root, data);
        setBenchmarkStatus(root, "", "ready");
        initAll(root);
        window.shoptimizerInsightsTracking?.reportViewed(root,
          data.mode === "competitors" ? "competitors" : "benchmark", base + ":" + slug);
      })
      .catch(function (err) {
        var message = (root.dataset.errorText == null ? reportCopy(root).benchmark_error : root.dataset.errorText);
        if (err.message === "not_found") message = (root.dataset.notfoundText == null ? reportCopy(root).benchmark_not_found : root.dataset.notfoundText);
        else if (err.message === "global_limit" || err.message === "rate_limited") message = reportCopy(root).unavailable;
        else if (err.name === "AbortError") message = reportCopy(root).timeout;
        setBenchmarkStatus(root, message, "failed");
      })
      .finally(function () { clearTimeout(timeout); });
  }

  function slugFor(root) {
    var param = (root.dataset.slugParam || "slug").trim() || "slug";
    return new URLSearchParams(window.location.search).get(param) || "";
  }

  function boot(scope) {
    var target = scope && scope.querySelectorAll ? scope : document;
    var roots = target.querySelectorAll("[data-oi-benchmark]");
    if (!roots.length) { initAll(target); return; }
    roots.forEach(function (root) {
      if (root.dataset.oiReady === "true") return;
      root.dataset.oiReady = "true";
      try {
        var rawReturn = new URLSearchParams(window.location.search).get("returnTo") || "";
        if (rawReturn.charAt(0) === "/" && rawReturn.slice(0, 2) !== "//") {
          var parsedReturn = new URL(rawReturn, window.location.href);
          if (parsedReturn.origin === new URL(window.location.href).origin) {
            ["company", "competitors", "benchmark", "search", "placeId", "returnTo"].forEach(function (key) {
              parsedReturn.searchParams.delete(key);
            });
            root.dataset.returnTo = parsedReturn.pathname + parsedReturn.search + parsedReturn.hash;
            var back = root.querySelector("[data-oi-back]");
            if (back) back.href = localPageUrl(root.dataset.returnTo, root);
          }
        }
      } catch (err) { root.dataset.returnTo = ""; }
      var slug = slugFor(root);
      var base = (root.dataset.apiBase || "").trim();
      if (!base && !slug && root.dataset.designMode === "true") {
        setBenchmarkStatus(root, reportCopy(root).design_preview, "ready");
        initAll(root);
        return;
      }
      if (!base || !slug) {
        setBenchmarkStatus(root, !base ? reportCopy(root).connection_missing : reportCopy(root).select_location, "failed");
        return;
      }
      loadBenchmark(root, slug);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(document); });
  } else {
    boot(document);
  }

  // Shopify-Theme-Editor: Section neu geladen -> Karte im betroffenen Bereich neu initialisieren.
  document.addEventListener("shopify:section:load", function (e) {
    boot(e.target || document);
  });
  document.addEventListener("shopify:section:unload", function (e) {
    e.target.querySelectorAll("[data-oi-map]").forEach(function (el) {
      if (el.oiMapCleanup) el.oiMapCleanup();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insights-hero-analyzer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function createLifecycle(hero) {
    var controller = new AbortController();
    var cleanups = [];
    var lifecycle = {
      signal: controller.signal,
      listen: function (target, type, listener, options) {
        target.addEventListener(type, listener, Object.assign({}, options, { signal: controller.signal }));
      },
      cleanup: function (callback) { cleanups.push(callback); },
      destroy: function () {
        if (controller.signal.aborted) return;
        controller.abort();
        cleanups.forEach(function (callback) { callback(); });
        cleanups.length = 0;
        delete hero._oiDestroy;
        delete hero.dataset.oiReady;
      }
    };
    hero._oiDestroy = lifecycle.destroy;
    return lifecycle;
  }

  function initStarfield(canvas, pattern, lifecycle, motifZone) {
    var started = false;
    function startStarfield() {
      if (started || lifecycle.signal.aborted || !window.ShoptimizerStarfield) return;
      started = true;
      window.ShoptimizerStarfield.init(canvas, pattern, lifecycle,
        canvas.getAttribute("data-show-formation") === "false" ? null : motifZone);
    }
    lifecycle.listen(document, "shoptimizer:starfield:ready", startStarfield);
    startStarfield();
  }

  /** Vorschlagsliste aus dem Textarea-Setting: "Name|Untertitel|URL" je Zeile. */
  var ICON_SEARCH =
    '<svg viewBox="0 0 20 20" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round"><circle cx="8.5" cy="8.5" r="5.5"/><path d="M12.8 12.8 17 17"/></svg>';
  var ICON_PIN =
    '<svg viewBox="0 0 20 20" width="17" height="17" fill="currentColor">' +
    '<path d="M10 1.6a5.6 5.6 0 0 0-5.6 5.6c0 4.1 5.6 11.2 5.6 11.2s5.6-7.1 5.6-11.2A5.6 5.6 0 0 0 10 1.6zm0 7.7a2.1 2.1 0 1 1 0-4.2 2.1 2.1 0 0 1 0 4.2z"/></svg>';

  function parseSuggestions(raw) {
    return (raw || "")
      .split("\n")
      .map(function (line) { return line.trim(); })
      .filter(Boolean)
      .map(function (line) {
        var parts = line.split("|");
        var kind = (parts[3] || "").trim().toLowerCase();
        return {
          name: (parts[0] || "").trim(),
          sub: (parts[1] || "").trim(),
          url: (parts[2] || "").trim(),
          kind: kind === "suche" || kind === "query" ? "query" : "place"
        };
      })
      .filter(function (s) { return s.name; });
  }

  /** Erster Buchstabe groß — wie capitalizeQuery() der Demo (kein Title-Case). */
  function capitalizeQuery(str) {
    var s = String(str == null ? "" : str);
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
  }

  /** Basis-URL normalisieren: ohne Schrägstrich am Ende, sonst leer. */
  function apiBaseOf(hero) {
    var base = (hero.dataset.apiBase || "").trim();
    if (!base) return "";
    return base.replace(/\/+$/, "");
  }

  function localizedPageUrl(hero, value) {
    try {
      var current = new URL(window.location.href);
      var url = new URL(value, current);
      if (url.origin !== current.origin || !/^https?:$/.test(url.protocol)) return value;
      var root = (hero.dataset.rootUrl || "/").replace(/\/?$/, "/");
      if (url.pathname.indexOf("/pages/") === 0) url.pathname = root + url.pathname.slice(1);
      return url.pathname + url.search + url.hash;
    } catch (err) {
      return value;
    }
  }

  /** Platzhalter [q], [n] und [grund] in den Hinweistexten ersetzen. */
  function fillTemplate(tpl, values) {
    return String(tpl || "").replace(/\[(q|n|grund)\]/g, function (_m, key) {
      return values[key] == null ? "" : String(values[key]);
    });
  }

  function sharedRequestHeaders(root) {
    var timer;
    var expired = false;
    var operation = Promise.resolve().then(function () {
      if (window.ShoptimizerAppCheck) return;
      if (!root.dataset.appCheckHelperUrl) throw new Error("app_check_configuration");
      return import(root.dataset.appCheckHelperUrl);
    }).then(function () {
      if (expired) throw new Error("app_check_timeout");
      return window.ShoptimizerAppCheck.getHeadersFromElement(root);
    });
    return Promise.race([operation, new Promise(function (_resolve, reject) {
      timer = setTimeout(function () { expired = true; reject(new Error("app_check_timeout")); }, 30000);
    })]).finally(function () { clearTimeout(timer); });
  }

  function appCheckToken(hero) {
    return sharedRequestHeaders(hero).then(function (headers) {
      return headers["X-Firebase-AppCheck"];
    });
  }

  function sourcePageOf(hero) {
    try {
      var url = new URL(window.location.href);
      var path = url.pathname.replace(/^\/(?:de|en|fr|it|nl|es)(?:-[a-z]{2})?(?=\/|$)/i, "").replace(/\/$/, "");
      var page = path.indexOf("/pages/") === 0 ? path.slice(7) : "";
      if (path === "" && hero.dataset.homepage === "true") return "homepage";
      if (path === "/pages/contact-us") page = url.searchParams.get("view") || "";
      if (path === "/pages") page = hero.dataset.sourcePage || "";
      return ["insights-search", "insights-single", "insights-competitors", "insights-top-standorte"].indexOf(page) !== -1 ? page : "";
    } catch (err) { return ""; }
  }

  function createRequestSignal(signal, milliseconds) {
    var controller = new AbortController();
    var timer;
    function cleanup() {
      clearTimeout(timer);
      signal.removeEventListener("abort", abort);
    }
    function abort() {
      cleanup();
      controller.abort();
    }
    if (signal.aborted) abort();
    else {
      signal.addEventListener("abort", abort, { once: true });
      timer = setTimeout(abort, milliseconds);
    }
    return { signal: controller.signal, cleanup: cleanup };
  }

  function retryDelay(value) {
    if (value == null || value === "") return 0;
    var number = Number(value);
    var seconds = Number.isFinite(number) ? number : (Date.parse(value) - Date.now()) / 1000;
    return Number.isFinite(seconds) && seconds > 0 ? Math.min(seconds, 86400) * 1000 : 0;
  }

  function createEventStream(url, headers, onLimit) {
    var controller = new AbortController();
    var listeners = {};
    var closed = false;
    function emit(name, data) {
      if (!closed && listeners[name]) listeners[name]({ data: data });
    }
    var stream = {
      addEventListener: function (name, callback) { listeners[name] = callback; },
      close: function () { closed = true; controller.abort(); }
    };
    fetch(url, { headers: headers, credentials: "omit", signal: controller.signal })
      .then(async function (response) {
        if (response.status === 429 || response.status === 503) {
          if (onLimit) onLimit(response.headers?.get("Retry-After"));
          emit("error", JSON.stringify({ error: "global_limit" }));
          return;
        }
        if (!response.ok || !response.body ||
            !(response.headers.get("Content-Type") || "").includes("text/event-stream")) {
          throw new Error("stream_unavailable");
        }
        var reader = response.body.getReader();
        var decoder = new TextDecoder();
        var buffer = "";
        var eventName = "message";
        var data = [];
        while (!closed) {
          var chunk = await reader.read();
          if (chunk.done) break;
          buffer += decoder.decode(chunk.value, { stream: true });
          var newline;
          while (!closed && (newline = buffer.indexOf("\n")) !== -1) {
            var line = buffer.slice(0, newline).replace(/\r$/, "");
            buffer = buffer.slice(newline + 1);
            if (!line) {
              if (data.length) emit(eventName, data.join("\n"));
              eventName = "message";
              data = [];
            } else if (line.startsWith("event:")) {
              eventName = line.slice(6).trim();
            } else if (line.startsWith("data:")) {
              data.push(line.slice(5).replace(/^ /, ""));
            }
          }
        }
        if (!closed) emit("error", null);
      }).catch(function () { if (!closed) emit("error", null); });
    return stream;
  }

  function initAutocomplete(hero, input, api, lifecycle) {
    var box = hero.querySelector("[data-oi-ac]");
    var list = hero.querySelector("[data-oi-ac-list]");
    if (!box || !list) return null;

    var staticItems = parseSuggestions(hero.dataset.suggestions);
    var PILL_LABEL = hero.dataset.suggestionPill || "";
    var live = !!(api && api.base);
    if (!live && !staticItems.length) return null;

    var mode = hero.dataset.analysisMode || "competitors";
    var matches = [];
    var activeIndex = -1;
    var debounceTimer = null;
    var requestId = 0;

    function close() {
      requestId++;
      clearTimeout(debounceTimer);
      box.hidden = true;
      input.setAttribute("aria-expanded", "false");
      input.removeAttribute("aria-activedescendant");
      activeIndex = -1;
    }

    function highlight() {
      var nodes = list.querySelectorAll(".oi-ac__item");
      for (var i = 0; i < nodes.length; i++) {
        var on = i === activeIndex;
        nodes[i].classList.toggle("is-active", on);
        nodes[i].setAttribute("aria-selected", on ? "true" : "false");
      }
      if (activeIndex >= 0 && nodes[activeIndex]) {
        input.setAttribute("aria-activedescendant", nodes[activeIndex].id);
        if (mode === "all") {
          var row = nodes[activeIndex].getBoundingClientRect();
          var visibleTop = list.getBoundingClientRect().top + list.clientTop;
          var visibleBottom = visibleTop + list.clientHeight;
          if (row.top < visibleTop) list.scrollTop += row.top - visibleTop;
          else if (row.bottom > visibleBottom) list.scrollTop += row.bottom - visibleBottom;
        }
      } else {
        input.removeAttribute("aria-activedescendant");
      }
    }

    function choose(index) {
      var item = matches[index];
      if (!item) return;
      input.value = item.name;
      close();
      if (live) {
        // The choice belongs to this suggestion, not to a separate mode control.
        api.start(item.query || item.name, {
          placeId: item.placeId,
          selectedPlaceName: item.placeId ? item.name : "",
          mode: item.mode
        });
        return;
      }
      if (item.url) window.location.href = localizedPageUrl(hero, item.url);
    }

    function paint() {
      if (!matches.length) { close(); return; }
      list.textContent = "";
      matches.forEach(function (s, i) {
        var li = document.createElement("li");
        li.className = "oi-ac__item";
        li.setAttribute("role", "option");
        li.setAttribute("aria-selected", "false");
        li.id = list.id + "-opt-" + i;

        var icon = document.createElement("span");
        icon.className = "oi-ac__icon oi-ac__icon--" + s.kind;
        icon.setAttribute("aria-hidden", "true");
        icon.innerHTML = s.kind === "query" ? ICON_SEARCH : ICON_PIN;

        var text = document.createElement("span");
        text.className = "oi-ac__text";
        var main = document.createElement("span");
        main.className = "oi-ac__main";
        main.textContent = s.name;
        text.appendChild(main);
        if (s.sub) {
          var sub = document.createElement("span");
          sub.className = "oi-ac__sub";
          sub.textContent = s.sub;
          text.appendChild(sub);
        }

        li.appendChild(icon);
        li.appendChild(text);
        var pillLabel = s.label || (s.kind === "query" ? PILL_LABEL : "");
        if (pillLabel) {
          var pill = document.createElement("span");
          pill.className = "oi-ac__pill";
          if (mode === "all" && s.mode) pill.setAttribute("data-analysis-kind", s.mode);
          pill.textContent = pillLabel;
          li.appendChild(pill);
        }
        li.addEventListener("click", function () { choose(i); });
        list.appendChild(li);
      });

      activeIndex = -1;
      box.hidden = false;
      input.setAttribute("aria-expanded", "true");
    }

    function renderStatic(query) {
      var q = query.toLowerCase();
      matches = staticItems.filter(function (s) {
        return s.name.toLowerCase().indexOf(q) !== -1 || s.sub.toLowerCase().indexOf(q) !== -1;
      }).slice(0, 6);
      paint();
    }

    function renderLive(query, submit) {
      clearTimeout(debounceTimer);
      var currentRequest = ++requestId;
      api.autocomplete(query, function (predictions, requestError) {
        // Verspätete Antwort einer älteren Eingabe verwerfen.
        if (currentRequest !== requestId || input.value.trim() !== query) return;
        matches = [];
        predictions.slice(0, 8).forEach(function (p) {
          var main = p.mainText || p.description || "";
          var suggestion = {
            kind: p.kind === "query" ? "query" : "place",
            // Freitext-Vorschläge liefert Google klein geschrieben — nur das
            // erste Wort für die Anzeige groß schreiben (wie in der Demo).
            name: p.kind === "query" ? capitalizeQuery(main) : main,
            sub: p.secondaryText || "",
            query: p.description || main,
            placeId: p.placeId || "",
            url: ""
          };
          if (mode === "all") {
            if (p.kind === "query") {
              matches.push(Object.assign({}, suggestion, {mode: "multi", placeId: "", label: hero.dataset.i18nLabelMulti}));
            } else if (p.placeId) {
              matches.push(Object.assign({}, suggestion, {mode: "single", label: hero.dataset.i18nLabelSingle}));
              matches.push(Object.assign({}, suggestion, {mode: "competitors", label: hero.dataset.i18nLabelCompetitors}));
            }
          } else if (mode === "multi") {
            if (p.kind === "query") matches.push(Object.assign({}, suggestion, { mode: mode, label: hero.dataset.i18nLabelMulti }));
          } else if (p.kind !== "query" && p.placeId) {
            matches.push(Object.assign({}, suggestion, {
              mode: mode, label: mode === "single" ? hero.dataset.i18nLabelSingle : hero.dataset.i18nLabelCompetitors
            }));
          }
        });
        if (submit && matches.length === 1) { choose(0); return; }
        paint();
        var error = hero.querySelector("[data-oi-error]");
        if (!requestError && !submit && error) error.hidden = true;
        if (requestError || submit) {
          if (error) {
            if (requestError === "places_unavailable") {
              error.textContent = hero.dataset.i18nPlacesUnavailable;
            } else if (requestError === "global_limit" || requestError === "rate_limited" || requestError === "budget_exhausted") {
              error.textContent = hero.dataset.i18nAnalysisUnavailable;

            } else if (requestError) {
              error.textContent = hero.dataset.i18nPlacesOffline;
            } else {
              error.textContent = matches.length ? hero.dataset.i18nChooseLocation : hero.dataset.i18nLocationNotFound;
            }
            error.hidden = false;
          }
        }
      });
    }

    lifecycle.cleanup(close);
    lifecycle.listen(input, "input", function () {
      requestId++;
      if (debounceTimer) clearTimeout(debounceTimer);
      var value = input.value.trim();
      // Die Places-Autocomplete-API antwortet erst ab drei Zeichen.
      if (!value || (live && value.length < 3)) { close(); return; }
      debounceTimer = setTimeout(function () {
        if (live) renderLive(value); else renderStatic(value);
      }, live ? 300 : 200);
    });

    lifecycle.listen(input, "keydown", function (e) {
      if (box.hidden) return;
      if (e.key === "ArrowDown") {
        e.preventDefault();
        activeIndex = Math.min(matches.length - 1, activeIndex + 1);
        highlight();
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        activeIndex = Math.max(0, activeIndex - 1);
        highlight();
      } else if (e.key === "Enter") {
        if (activeIndex >= 0) { e.preventDefault(); choose(activeIndex); }
      } else if (e.key === "Escape") {
        close();
      }
    });

    lifecycle.listen(document, "click", function (e) {
      if (!hero.contains(e.target)) close();
    });

    return { close: close, submit: function (query) { renderLive(query, true); } };
  }

  /** Lade-Ansicht im Editor vorführen und anschließend zum Formular zurückkehren. */
  function runLoadingView(hero, query, done, lifecycle) {
    var loading = hero.querySelector("[data-oi-loading]");
    var formView = hero.querySelector('[data-oi-view="form"]');
    var steps = hero.querySelectorAll("[data-oi-step]");
    if (!loading || !steps.length) { done(); return; }
    steps.forEach(function (step) {
      step.classList.remove("is-active", "is-done", "is-error");
      var dot = step.querySelector("[data-oi-step-dot]");
      if (dot) dot.textContent = "";
    });

    var queryEl = hero.querySelector("[data-oi-loading-query]");
    if (queryEl) queryEl.textContent = query.charAt(0).toUpperCase() + query.slice(1);

    if (formView) formView.hidden = true;
    loading.hidden = false;
    var heading = hero.querySelector("[data-oi-loading-heading]");
    if (heading) heading.focus();

    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var i = 0;
    var timer = null;
    lifecycle.cleanup(function () { clearTimeout(timer); });

    function next() {
      if (lifecycle.signal.aborted) return;
      if (i > 0) {
        var prev = steps[i - 1];
        prev.classList.remove("is-active");
        prev.classList.add("is-done");
        var prevDot = prev.querySelector("[data-oi-step-dot]");
        if (prevDot) prevDot.textContent = "✓";
      }
      if (i >= steps.length) { done(); return; }
      var step = steps[i];
      step.classList.add("is-active");
      var duration = parseInt(step.getAttribute("data-duration"), 10);
      if (isNaN(duration) || duration < 0) duration = 1200;
      if (reduced) duration = Math.min(duration, 300);
      i++;
      timer = setTimeout(next, duration);
    }
    next();
  }

  // --- Live-Analyse über die Insights-API ----------------------------------
  /**
   * Verdrahtet den Hero mit der Cloud Function: Autocomplete, SSE-Analyse,
   * Moduswechsel auf den Benchmark und Weiterleitung auf die Report-Seite.
   * Gibt null zurück, wenn keine Basis-URL hinterlegt ist — dann bleibt das
   * bisherige, rein statische Verhalten aktiv.
   */
  function initApi(hero, lifecycle) {
    var base = apiBaseOf(hero);
    if (!base) return null;

    var loading = hero.querySelector("[data-oi-loading]");
    var formView = hero.querySelector('[data-oi-view="form"]');
    var queryEl = hero.querySelector("[data-oi-loading-query]");
    var noticeEl = hero.querySelector("[data-oi-loading-notice]");
    var errorEl = hero.querySelector("[data-oi-error]");
    var steps = hero.querySelectorAll("[data-oi-step]");
    var stream = null;
    var streamTimer = null;
    var requestId = 0;
    var running = false;
    var searchTracked = false;
    var blockedUntil = 0;
    var autocompletePending = new Map();
    var sourcePage = sourcePageOf(hero);
    var currentMode = hero.dataset.analysisMode || "competitors";
    var multiLimit = parseInt(hero.dataset.multiLimit, 10) || 12;
    var competitorLimit = 5;

    function isHistoryReturn() {
      try {
        var timing = window.performance;
        var navigation = timing && typeof timing.getEntriesByType === "function" && timing.getEntriesByType("navigation")[0];
        return !!(navigation && navigation.type === "back_forward") || !!(timing && timing.navigation && timing.navigation.type === 2);
      } catch (err) { return false; }
    }

    function searchHistoryKey() {
      var entry = window.navigation && window.navigation.currentEntry;
      return "shoptimizer:insights:query:" + new URL(window.location.href).pathname + ":" + sourcePage + ":" +
        (hero.id || hero.dataset.analysisMode) + ":" + (entry && entry.key || "latest");
    }

    function rememberSearch(query) {
      try {
        if (typeof query === "string") window.sessionStorage.setItem(searchHistoryKey(), query);
      } catch (err) { /* Storage restrictions must not block a deliberate search. */ }
    }

    function restoreSearch(input) {
      if (!isHistoryReturn()) return;
      try {
        var saved = window.sessionStorage.getItem(searchHistoryKey());
        if (typeof saved === "string") input.value = saved;
      } catch (err) { /* The existing editable form remains available without tab storage. */ }
    }

    function rememberLimit(value) {
      var delay = retryDelay(value);
      if (delay) blockedUntil = Math.max(blockedUntil, Date.now() + delay);
    }

    function setMode(mode) {
      if (["single", "multi", "competitors"].indexOf(mode) === -1) return;
      currentMode = mode;
      if (hero.dataset.analysisMode === "all") return;
      var loadingTitle = hero.querySelector("[data-oi-loading-title]");
      var loadingKicker = hero.querySelector("[data-oi-loading-kicker]");
      if (loadingTitle) loadingTitle.textContent = hero.getAttribute("data-" + mode + "-loading-heading") || "";
      if (loadingKicker) {
        loadingKicker.textContent = hero.getAttribute("data-" + mode + "-loading-kicker") || "";
        loadingKicker.hidden = !loadingKicker.textContent;
      }
    }

    var statusPromise = null;
    function getStatus() {
      if (!statusPromise) {
        var request = createRequestSignal(lifecycle.signal, 8000);
        statusPromise = fetch(base + "/api/status", { credentials: "omit", signal: request.signal })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (data) {
            if (data && typeof data.multiLocationsLimit === "number") multiLimit = data.multiLocationsLimit;
            if (data && typeof data.competitorsShowLimit === "number") competitorLimit = data.competitorsShowLimit;
            if (!data || !data.appCheck) statusPromise = null;
            return data;
          })
          .catch(function () { statusPromise = null; return null; })
          .finally(request.cleanup);
      }
      return statusPromise;
    }
    getStatus();

    function showLoading(query, notice) {
      var wasRunning = running;
      running = true;
      if (formView) formView.hidden = true;
      if (loading) loading.hidden = false;
      if (queryEl) queryEl.textContent = capitalizeQuery(query);
      if (noticeEl) {
        if (notice) { noticeEl.textContent = notice; noticeEl.hidden = false; }
        else { noticeEl.textContent = ""; noticeEl.hidden = true; }
      }
      var heading = hero.querySelector("[data-oi-loading-heading]");
      if (!wasRunning && heading) heading.focus();
    }

    function showForm(message) {
      var restoreFocus = running && loading && loading.contains(document.activeElement);
      running = false;
      if (loading) loading.hidden = true;
      if (formView) formView.hidden = false;
      if (errorEl) {
        if (message) { errorEl.textContent = message; errorEl.hidden = false; }
        else { errorEl.hidden = true; }
      }
      if (restoreFocus && input) input.focus();
    }

    /** Schritte zurücksetzen und die Beschriftungen des Modus einsetzen. */
    function resetSteps(mode) {
      for (var i = 0; i < steps.length; i++) {
        var li = steps[i];
        li.classList.remove("is-active", "is-done", "is-error");
        var dot = li.querySelector("[data-oi-step-dot]");
        if (dot) dot.textContent = "";
        var detail = li.querySelector(".oi-step__detail");
        if (detail) detail.textContent = "";
        var label = li.querySelector(".oi-step__label");
        if (label) {
          var multi = li.getAttribute("data-label-multi");
          var single = li.getAttribute("data-label") || label.textContent;
          var competitors = li.getAttribute("data-label-competitors");
          label.textContent = hero.dataset.analysisMode === "all" ?
            (mode === "competitors" ? competitors : mode === "multi" ? multi : li.getAttribute("data-label")) :
            mode === "competitors" ? (competitors || "") :
            mode === "multi" && multi ? multi : single;
        }
      }
    }

    function updateStep(data) {
      var li = null;
      for (var i = 0; i < steps.length; i++) {
        if (steps[i].getAttribute("data-step-id") === data.id) { li = steps[i]; break; }
      }
      if (!li) return;
      li.classList.remove("is-active", "is-done", "is-error");
      if (data.status === "done") li.classList.add("is-done");
      else if (data.status === "error") li.classList.add("is-error");
      else li.classList.add("is-active");
      var dot = li.querySelector("[data-oi-step-dot]");
      if (dot) dot.textContent = data.status === "done" ? "✓" : data.status === "error" ? "!" : "";
      var detail = li.querySelector(".oi-step__detail");
      if (detail) detail.textContent = data.status === "done" ?
        (li.getAttribute(currentMode === "single" ? "data-detail" : "data-detail-" + currentMode) || "") : "";
    }

    function closeStream() {
      requestId++;
      clearTimeout(streamTimer);
      streamTimer = null;
      if (stream) {
        try { stream.close(); } catch (err) { /* bereits geschlossen */ }
        stream = null;
      }
    }

    function targetUrl(kind) {
      var url = kind === "multi" || kind === "competitors" ? hero.dataset.benchmarkUrl : hero.dataset.reportUrl;
      url = (url || "").trim();
      var root = (hero.dataset.rootUrl || "/").replace(/\/?$/, "/");
      return localizedPageUrl(hero, url || root + (kind === "single" ? "pages/insights-report" : "pages/insights-benchmark"));
    }

    function addParam(url, key, value) {
      var hashAt = url.indexOf("#");
      var hash = hashAt === -1 ? "" : url.slice(hashAt);
      var beforeHash = hashAt === -1 ? url : url.slice(0, hashAt);
      return beforeHash + (beforeHash.indexOf("?") !== -1 ? "&" : "?") +
        encodeURIComponent(key) + "=" + encodeURIComponent(value) + hash;
    }

    function returnTarget() {
      try {
        var current = new URL(window.location.href);
        ["company", "competitors", "benchmark", "search", "placeId", "returnTo"].forEach(function (key) {
          current.searchParams.delete(key);
        });
        return current.pathname + current.search + current.hash;
      } catch (err) {
        return hero.dataset.rootUrl || "/";
      }
    }

    function openReport(kind, slug, headers) {
      if (lifecycle.signal.aborted) return;
      function navigate(reportKind) {
        if (lifecycle.signal.aborted) return;
        var param = (hero.dataset.slugParam || "slug").trim() || "slug";
        var url = addParam(targetUrl(reportKind), param, slug);
        window.location.href = addParam(url, "returnTo", returnTarget());
      }
      var handoff = window.OptimizzerReportHandoff;
      if (!handoff || !handoff.available()) { navigate(kind); return; }
      var currentRequest = requestId;
      handoff.prepare(base, slug, headers, lifecycle.signal).then(function (reportKind) {
        if (currentRequest !== requestId || lifecycle.signal.aborted) return;
        if (!reportKind) { navigate(kind); return; }
        navigate(reportKind === "single" ? "single" : kind === "single" ? "multi" : kind);
      }).catch(function () {
        if (currentRequest === requestId && !lifecycle.signal.aborted) fail(null);
      });
    }

    function fail(message) {
      closeStream();
      showForm(message ?? hero.dataset.apiError ?? hero.dataset.i18nAnalysisFailed);
    }

    /**
     * Öffnet einen SSE-Stream und verdrahtet die Ereignisse. `onSwitch` wird
     * nur im Einzelmodus gesetzt (mode-switch existiert dort).
     */
    function openStream(path, params, kind, onSwitch, headers) {
      if (lifecycle.signal.aborted) return;
      closeStream();
      params = Object.assign({}, params);
      if (sourcePage) params.sourcePage = sourcePage;
      try {
        var attribution = window.shoptimizerRequestContext?.attribution();
        if (attribution) params.attribution = JSON.stringify(attribution);
      } catch (err) {}
      var qs = [];
      Object.keys(params).forEach(function (key) {
        if (params[key]) qs.push(encodeURIComponent(key) + "=" + encodeURIComponent(params[key]));
      });
      var es = createEventStream(base + path + (qs.length ? "?" + qs.join("&") : ""), headers, rememberLimit);
      // Count the original manual request, even without progress or on failure.
      // Internal mode switches share this flag; another deliberate start resets it.
      if (!searchTracked && params.via !== "link") {
        searchTracked = true;
        try { window.shoptimizerInsightsTracking?.track("search_started", {}); } catch (err) { /* best effort */ }
      }
      stream = es;
      // Bound the entire request, even if keepalive pings continue but a provider
      // never finishes. Close explicitly; a paid run is never automatically retried.
      streamTimer = setTimeout(function () {
        if (stream === es) fail(hero.dataset.i18nAnalysisTimeout);
      }, 110000);
      var gotEvent = false;

      es.addEventListener("step", function (evt) {
        gotEvent = true;
        try {
          var step = JSON.parse(evt.data);
          updateStep(step);
        } catch (err) { /* fehlerhaftes Ereignis ignorieren */ }
      });
      if (onSwitch) {
        es.addEventListener("mode-switch", function (evt) {
          gotEvent = true;
          var data = {};
          try { data = JSON.parse(evt.data); } catch (err) { /* leer lassen */ }
          closeStream();
          onSwitch(data);
        });
      }
      es.addEventListener("done", function (evt) {
        gotEvent = true;
        var data = {};
        try { data = JSON.parse(evt.data); } catch (err) { /* leer lassen */ }
        closeStream();
        if (data.slug) openReport(kind, data.slug, headers);
        else fail(null);
      });
      es.addEventListener("error", function (evt) {
        // Servertexte können aus älteren Backends interne Limitdetails enthalten.
        // Öffentliche Fehler bleiben statisch; Retry-Metadaten lösen keinen Lauf aus.
        var message = null;
        if (evt && evt.data) {
          message = hero.dataset.i18nAnalysisUnavailable;
          var data = null;
          try { data = JSON.parse(evt.data); } catch (err) {}
          if (data && ["global_limit", "rate_limited", "budget_exhausted", "QuotaExceeded"].indexOf(data.error) !== -1) rememberLimit(data.retryAfterSeconds);
          if (kind === "competitors" && data &&
              (data.message === "Für diesen Standort lässt sich die Branche nicht zuverlässig bestimmen. Eine faire Konkurrenzanalyse ist deshalb derzeit nicht möglich. Bitte wählen Sie die Einzelanalyse." ||
               data.message === "Die Branche dieses Standorts ist nicht eindeutig zugeordnet. Deshalb können wir derzeit keine verlässlich vergleichbaren Mitbewerber anzeigen.")) {
            message = hero.dataset.comparisonUnavailable;
          } else if (kind === "competitors" && data &&
              data.message === "Für diese Branche haben wir im Umkreis noch keine verlässlich vergleichbaren Mitbewerber gefunden.") {
            message = hero.dataset.i18nNoCompetitors;
          }
        } else if (!gotEvent) {
          message = hero.dataset.apiOffline ?? hero.dataset.i18nAnalysisOffline;
        }
        fail(message);
      });
    }

    function requestHeaders() {
      if (lifecycle.signal.aborted) return Promise.reject(new Error("section_unloaded"));
      return appCheckToken(hero).then(function (token) {
        if (lifecycle.signal.aborted) throw new Error("section_unloaded");
        if (!token) throw new Error("app_check_configuration");
        return { "X-Firebase-AppCheck": token };
      });
    }

    function requestStream(path, params, kind, onSwitch) {
      closeStream();
      var currentRequest = requestId;
      requestHeaders().then(function (headers) {
        if (currentRequest === requestId && running) openStream(path, params, kind, onSwitch, headers);
      }).catch(function () {
        if (currentRequest === requestId && running) {
          fail(hero.dataset.i18nSecurityUnavailable);
        }
      });
    }

    function startSingle(query, opts) {
      opts = opts || {};
      setMode("single");
      resetSteps("single");
      showLoading(query, opts.notice || "");
      requestStream("/api/analyze/stream", {
        query: query, placeId: opts.placeId || "", selectedPlaceName: opts.placeId ? (opts.selectedPlaceName || "").slice(0, 200) : "", location: opts.location || "", via: opts.via || "search"
      }, "single", function (data) {
        if (data.mode !== "multi") { fail(null); return; }
        if (opts.via !== "link" && !opts.allowMulti) {
          fail(hero.dataset.i18nChooseSpecificLocation);
          return;
        }
        startMulti(data.query || query, {
          via: opts.via || "search",
          notice: fillTemplate(hero.dataset.switchNotice, {
            q: capitalizeQuery(query), grund: data.reason || "", n: multiLimit
          })
        });
      });
    }

    function startMulti(query, opts) {
      opts = opts || {};
      setMode("multi");
      resetSteps("multi");
      var defaultNotice = fillTemplate(hero.dataset.multiNotice, {
        q: capitalizeQuery(query), n: multiLimit
      });
      showLoading(query, hero.dataset.analysisMode === "all" ? (opts.notice ?? defaultNotice) : (opts.notice || defaultNotice));
      requestStream("/api/analyze-multi/stream", { query: query, via: opts.via || "search" }, "multi", null);
    }

    function startCompetitors(query, opts) {
      opts = opts || {};
      setMode("competitors");
      resetSteps("competitors");
      showLoading(query, fillTemplate(hero.dataset.competitorsNotice, {n: competitorLimit, q: query}));
      requestStream("/api/analyze-competitors/stream", {
        query: query, placeId: opts.placeId || "", selectedPlaceName: opts.placeId ? (opts.selectedPlaceName || "").slice(0, 200) : "", via: opts.via || "search"
      }, "competitors", null);
    }

    function start(query, opts) {
      if (running || lifecycle.signal.aborted) return;
      if (Date.now() < blockedUntil) { showForm(hero.dataset.i18nAnalysisUnavailable); return; }
      searchTracked = false;
      opts = opts || {};
      var mode = opts.mode || hero.dataset.analysisMode || "competitors";
      rememberSearch(query);
      if (mode === "all" && !opts.placeId) opts = Object.assign({}, opts, {allowMulti: true});
      if (mode === "competitors") startCompetitors(query, opts);
      else if (mode === "multi") startMulti(query, opts);
      else startSingle(query, opts);
    }

    function resolveLink(input) {
      // A page can contain several hero sections. Only the first consumes the
      // link, and ordinary page visits cause no resolve or analysis request.
      if (lifecycle.signal.aborted || window._oiDeepLinkHandled || isHistoryReturn()) return;
      var incoming = new URLSearchParams(window.location.search);
      var params = new URLSearchParams();
      ["competitors", "company", "benchmark", "search"].forEach(function (key) {
        if (incoming.get(key)) params.set(key, incoming.get(key));
      });
      if (!params.toString()) return;
      if (sourcePage) params.set("sourcePage", sourcePage);
      window._oiDeepLinkHandled = lifecycle;
      lifecycle.cleanup(function () {
        if (window._oiDeepLinkHandled === lifecycle) delete window._oiDeepLinkHandled;
      });
      if (incoming.get("placeId")) params.set("placeId", incoming.get("placeId"));
      var initialInput = input.value;
      var initialMode = currentMode;
      var request;
      requestHeaders().then(function (headers) {
        if (lifecycle.signal.aborted) throw new Error("section_unloaded");
        try {
          var attribution = window.shoptimizerRequestContext?.attribution();
          if (attribution) params.set("attribution", JSON.stringify(attribution));
        } catch (err) {}
        request = createRequestSignal(lifecycle.signal, 15000);
        return fetch(base + "/api/resolve?" + params.toString(), { credentials: "omit", headers: headers, signal: request.signal });
      })
        .then(function (res) {
          if (res.status === 429 || res.status === 503) { rememberLimit(res.headers?.get("Retry-After")); throw new Error("global_limit"); }
          if (!res.ok) throw new Error("resolve_failed");
          return res.json();
        })
        .then(function (data) {
          // Typing or submitting while the link resolves wins over a late response.
          if (lifecycle.signal.aborted || running || input.value !== initialInput || currentMode !== initialMode || !data || !data.query) return;
          if (["search", "single", "multi", "competitors"].indexOf(data.mode) === -1) return;
          input.value = data.query;
          if (data.mode === "search") { rememberSearch(data.query); input.focus(); return; }
          start(data.query, { mode: data.mode, placeId: data.placeId || "", via: "link" });
        })
        .catch(function (err) {
          if (!lifecycle.signal.aborted && !running && input.value === initialInput && currentMode === initialMode) {
            showForm(err.message === "global_limit" ?
              hero.dataset.i18nAnalysisUnavailable : hero.dataset.i18nLinkFailed);
          }
        }).finally(function () { if (request) request.cleanup(); });
    }

    function autocomplete(query, cb) {
      if (Date.now() < blockedUntil) { cb([], "global_limit"); return; }
      var pending = autocompletePending.get(query);
      if (!pending) {
        pending = requestHeaders().then(function (headers) {
        return fetch(base + "/api/autocomplete?input=" + encodeURIComponent(query), { credentials: "omit", headers: headers, signal: lifecycle.signal });
      })
        .then(function (res) {
          if (res.status === 429 || res.status === 503) { rememberLimit(res.headers?.get("Retry-After")); return { predictions: [], error: "global_limit" }; }
          return res.json().catch(function () { return {}; }).then(function (data) {
            if (res.ok) {
              return data && Array.isArray(data.predictions) ? data :
                { predictions: [], error: "autocomplete_unavailable" };
            }
            return { predictions: [], error: "autocomplete_unavailable" };
          });
        })
        .catch(function () { return {predictions: [], error: "autocomplete_unavailable"}; })
        .finally(function () { if (autocompletePending.get(query) === pending) autocompletePending.delete(query); });
        autocompletePending.set(query, pending);
      }
      pending.then(function (data) { if (!lifecycle.signal.aborted) cb((data && data.predictions) || [], data && data.error); });
    }

    var input = hero.querySelector("[data-oi-input]");
    if (input) lifecycle.listen(input, "focus", function () {
      if (hero.dataset.oiSilentFocus !== "true") requestHeaders().catch(function () {});
    });
    if (input) lifecycle.listen(input, "input", function () {
      requestHeaders().catch(function () {});
    }, {once:true});

    lifecycle.cleanup(function () { closeStream(); running = false; });
    lifecycle.listen(window, "pagehide", closeStream);
    lifecycle.listen(window, "pageshow", function (event) {
      // Browser Back can restore the landing document exactly as it looked
      // during the completed run. Resume an editable form, never the paid run.
      if (event.persisted) {
        closeStream();
        showForm("");
      }
    });

    return {
      base: base, start: start, getMode: function () { return currentMode; }, setMode: setMode,
      resolveLink: resolveLink, autocomplete: autocomplete, restoreSearch: restoreSearch
    };
  }

  function initHero(hero) {
    if (hero.dataset.oiReady === "true") return;
    hero.dataset.oiReady = "true";
    var lifecycle = createLifecycle(hero);

    var form = hero.querySelector("[data-oi-form]");
    var input = hero.querySelector("[data-oi-input]");
    var errorEl = hero.querySelector("[data-oi-error]");
    // Der Canvas bleibt auf den eigenen Hero-Container begrenzt.
    var landing = hero.closest("[data-oi-landing]") || hero;
    var canvas = landing.querySelector("[data-oi-canvas]");

    // Mehrfach eingefügte Heros sind unkritisch: Jeder Canvas deckt nur seinen
    // eigenen Landing-Container ab, zwei Felder können sich nicht überlagern.
    if (canvas && hero.dataset.starfield === "true") {
      var pattern = hero.dataset.starfieldPattern || "star";
      if (pattern !== "off") initStarfield(canvas, pattern, lifecycle, landing.querySelector("[data-oi-motif-zone]"));
      else canvas.style.display = "none";
    }

    if (!form || !input) return;

    var api = initApi(hero, lifecycle);
    var ac = initAutocomplete(hero, input, api, lifecycle);
    if (api) { api.restoreSearch(input); api.resolveLink(input); }

    function finishPreview() {
      var loading = hero.querySelector('[data-oi-loading]');
      var formView = hero.querySelector('[data-oi-view="form"]');
      var restoreFocus = loading && loading.contains(document.activeElement);
      if (loading) loading.hidden = true;
      if (formView) formView.hidden = false;
      if (restoreFocus) input.focus();
    }

    lifecycle.listen(form, "submit", function (e) {
      e.preventDefault();
      if (!api && hero.dataset.designMode !== "true") return;
      var value = (input.value || "").trim();
      if (!value) {
        if (errorEl) {
          errorEl.textContent = hero.dataset.error ?? hero.dataset.i18nQueryRequired;
          errorEl.hidden = false;
        }
        input.focus();
        return;
      }
      if (errorEl) errorEl.hidden = true;
      if (ac) ac.close();

      if (api) {
        if (hero.dataset.analysisMode === "competitors") {
          window.shoptimizerInsightsTracking?.track("cta_clicked", {target: "compare"});
        }
        if (ac && hero.dataset.analysisMode !== "multi" && hero.dataset.analysisMode !== "all") ac.submit(value);
        else api.start(value, {});
      } else if (hero.dataset.showLoading === "true") {
        runLoadingView(hero, value, finishPreview, lifecycle);
      } else {
        finishPreview();
      }
    });

    lifecycle.listen(input, "input", function () {
      if (errorEl && !errorEl.hidden) errorEl.hidden = true;
    });
  }

  var homepageFocusAttempted = false;

  function focusHomepageSearch(heroes) {
    if (homepageFocusAttempted || !heroes.length) return;
    homepageFocusAttempted = true;
    var hero = heroes[0];
    if (hero.dataset.homepage !== "true" || hero.dataset.designMode === "true") return;
    if (!window.matchMedia("(min-width: 990px) and (hover: hover) and (pointer: fine)").matches) return;
    var input = hero.querySelector("[data-oi-input]");
    if (!input || input.disabled || !input.getClientRects().length) return;
    if (document.activeElement !== document.body && document.activeElement !== document.documentElement) return;
    var openModal = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).some(function (modal) {
      return modal.getClientRects().length && window.getComputedStyle(modal).visibility !== "hidden";
    });
    if (openModal) return;
    var params = new URL(window.location.href).searchParams;
    if (window.location.hash || window.scrollY > 0 ||
        ["company", "competitors", "benchmark", "search"].some(function (key) { return params.has(key); })) return;
    hero.dataset.oiSilentFocus = "true";
    input.focus({preventScroll:true});
    delete hero.dataset.oiSilentFocus;
  }

  function boot() {
    var heroes = document.querySelectorAll("[data-oi-hero]");
    for (var i = 0; i < heroes.length; i++) {
      var form = heroes[i].querySelector("[data-oi-form]");
      if (form) form.id = i === 0 ? "insights-suche" : form.getAttribute("data-instance-id");
      initHero(heroes[i]);
    }
    focusHomepageSearch(heroes);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  // Im Theme-Editor wird die Section neu eingehängt.
  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("shopify:section:unload", function (event) {
    event.target.querySelectorAll("[data-oi-hero]").forEach(function (hero) {
      if (hero._oiDestroy) hero._oiDestroy();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insights-report-demo"] && !Shopify.designMode) return;
  try {
    
(function () {
  function requestHeaders(root) {
    var timer;
    var expired = false;
    var operation = Promise.resolve().then(function () {
      if (window.ShoptimizerAppCheck) return;
      if (!root.dataset.appCheckHelperUrl) throw new Error("app_check_configuration");
      return import(root.dataset.appCheckHelperUrl);
    }).then(function () {
      if (expired) throw new Error("app_check_timeout");
      return window.ShoptimizerAppCheck.getHeadersFromElement(root);
    });
    return Promise.race([operation, new Promise(function (_resolve, reject) {
      timer = setTimeout(function () { expired = true; reject(new Error("app_check_timeout")); }, 30000);
    })]).finally(function () { clearTimeout(timer); });
  }

  "use strict";

  // Rendert bei ?slug=… den echten Report aus /api/analysis/:slug in das
  // bestehende Markup. Ohne Slug oder ohne API-Basis-URL bleiben die im
  // Theme-Editor gepflegten Demo-Inhalte unangetastet.

  function textOf(node, value) {
    if (node) node.textContent = value == null ? "" : String(value);
  }

  // Structural UI comes from Liquid; provider review text remains in its source language.
  function reportCopy(root) {
    return root.oiReportCopy || (root.oiReportCopy = JSON.parse(root.dataset.reportI18n || "{}"));
  }

  function formatNumber(value, root, digits) {
    if (value == null || value === "" || !isFinite(Number(value))) return "—";
    return Number(value).toLocaleString(root.dataset.locale, digits == null ? {} : {
      minimumFractionDigits: digits, maximumFractionDigits: digits
    });
  }

  function formatPercent(value, root) {
    return value == null || value === "" || !isFinite(Number(value)) ? "—" :
      (Number(value) / 100).toLocaleString(root.dataset.locale, {style: "percent", maximumFractionDigits: 2});
  }

  function localPageUrl(value, root) {
    if (!value) return value;
    try {
      var url = new URL(value, window.location.href);
      var prefix = (root.dataset.rootUrl || "/").replace(/\/$/, "");
      if (url.origin === new URL(window.location.href).origin && prefix &&
          (url.pathname === "/" || url.pathname.indexOf("/pages/") === 0)) {
        url.pathname = prefix + url.pathname;
        return url.pathname + url.search + url.hash;
      }
    } catch (err) { /* Preserve the merchant's link if it cannot be parsed. */ }
    return value;
  }

  function formatDate(iso, root) {
    if (typeof iso !== "string" || !iso) return "";
    try {
      var provider = /^(\d{1,2})\/(\d{1,2})\/(\d{4})(?: \d{2}:\d{2}:\d{2})?$/.exec(iso);
      if (provider) {
        var month = Number(provider[1]), day = Number(provider[2]), year = Number(provider[3]);
        var calendar = new Date(Date.UTC(year, month - 1, day));
        if (calendar.getUTCFullYear() !== year || calendar.getUTCMonth() !== month - 1 || calendar.getUTCDate() !== day) return "";
        return calendar.toLocaleDateString(root.dataset.locale, {day: "2-digit", month: "2-digit", year: "numeric", timeZone: "UTC"});
      }
      var date = new Date(iso);
      if (!isFinite(date.getTime())) return "";
      return date.toLocaleDateString(root.dataset.locale, { day: "2-digit", month: "2-digit", year: "numeric" });
    } catch (err) {
      return "";
    }
  }

  function starRow(rating) {
    var r = Math.round(Number(rating) || 0);
    if (r < 0) r = 0;
    if (r > 5) r = 5;
    return new Array(r + 1).join("★") + new Array(6 - r).join("☆");
  }

  function initialsOf(name) {
    var words = String(name || "").trim().split(/\s+/).filter(Boolean);
    if (!words.length) return "?";
    return ((words[0][0] || "") + (words.length > 1 ? words[1][0] : "")).toUpperCase();
  }

  function fillTemplate(tpl, values) {
    return String(tpl || "").replace(/\[(datum|zeit|n|answered)\]/g, function (_m, key) {
      return values[key] == null ? "" : String(values[key]);
    });
  }

  function clearNode(node) {
    if (node) node.textContent = "";
  }

  /**
   * Lässt eine fremde Adresse nur dann als Link zu, wenn sie sich als absolute
   * http- oder https-Adresse lesen lässt. Die Website stammt aus dem Google-
   * Unternehmensprofil und ist damit die einzige Fremdangabe, die in ein
   * href laufen würde; Werte wie "javascript:…" oder unvollständige Eingaben
   * liefern null und werden von der Meta-Zeile als reiner Text ausgegeben —
   * sichtbar, aber nicht anklickbar.
   */
  function httpUrl(value) {
    var raw = String(value == null ? "" : value).trim();
    if (!raw) return null;
    try {
      var parsed = new URL(raw);
      if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return null;
      return parsed.href;
    } catch (err) {
      return null;
    }
  }

  /** Ersetzt Bild bzw. Initialen-Avatar im Report-Kopf. */
  function renderThumb(root, name, photo) {
    var header = root.querySelector("[data-oi-header]");
    if (!header) return;
    var old = header.querySelector(".oi-thumb, .oi-avatar");
    if (!old) return;
    var initials = initialsOf(name);
    var replacement;
    if (photo) {
      replacement = document.createElement("div");
      replacement.className = "oi-thumb";
      var img = document.createElement("img");
      img.className = "oi-thumb-img";
      img.src = photo;
      img.alt = name || "";
      img.loading = "lazy";
      var fallback = document.createElement("div");
      fallback.className = "oi-avatar";
      fallback.setAttribute("aria-hidden", "true");
      fallback.textContent = initials;
      fallback.style.display = "none";
      img.addEventListener("error", function () {
        img.style.display = "none";
        fallback.style.display = "flex";
      });
      replacement.appendChild(img);
      replacement.appendChild(fallback);
    } else {
      replacement = document.createElement("div");
      replacement.className = "oi-avatar";
      replacement.setAttribute("aria-hidden", "true");
      replacement.textContent = initials;
    }
    old.parentNode.replaceChild(replacement, old);
  }

  function renderMeta(root, place) {
    var meta = root.querySelector("[data-oi-meta]");
    if (!meta) return;
    clearNode(meta);
    var parts = [];
    if (place.category) parts.push({ text: place.category });
    if (place.address) parts.push({ text: place.address });
    if (place.website) parts.push({ text: place.website, href: httpUrl(place.website) });
    parts.forEach(function (part, i) {
      if (i > 0) meta.appendChild(document.createTextNode(" · "));
      if (part.href) {
        var a = document.createElement("a");
        a.href = part.href;
        a.target = "_blank";
        a.rel = "noopener";
        a.textContent = part.text;
        meta.appendChild(a);
      } else {
        meta.appendChild(document.createTextNode(part.text));
      }
    });
  }

  function renderDistribution(root, distribution) {
    var card = root.querySelector("[data-oi-dist-card]");
    if (!card) return;
    var rows = card.querySelectorAll(".oi-dist-row");
    var values = [5, 4, 3, 2, 1].map(function (star) {
      return Number(distribution && distribution[star]) || 0;
    });
    var max = Math.max.apply(null, [1].concat(values));
    for (var i = 0; i < rows.length && i < values.length; i++) {
      var pct = Math.round((values[i] / max) * 100);
      var fill = rows[i].querySelector(".oi-dist-bar-fill");
      if (fill) fill.style.width = pct + "%";
      textOf(rows[i].querySelector(".oi-dist-count"), formatNumber(values[i], root));
    }
  }

  /**
   * Zeichnet den Trendverlauf neu. Die API liefert je Monat den
   * Durchschnitt (avg) — daher wie in der Referenz eine feste Skala 1–5.
   */
  function renderTrend(root, trend) {
    var card = root.querySelector("[data-oi-trend-card]");
    var host = root.querySelector("[data-oi-trend]");
    if (!card || !host) return;
    if (!trend || trend.length < 2) {
      card.hidden = true;
      return;
    }
    card.hidden = false;

    var W = 560, H = 160, padL = 30, padR = 10, padT = 14, padB = 24;
    var xStep = (W - padL - padR) / Math.max(1, trend.length - 1);
    var yFor = function (val) {
      var v = Number(val);
      if (isNaN(v)) v = 1;
      if (v < 1) v = 1;
      if (v > 5) v = 5;
      return padT + (1 - (v - 1) / 4) * (H - padT - padB);
    };
    var labelStep = Math.ceil(trend.length / 6) || 1;
    var NS = "http://www.w3.org/2000/svg";

    var svg = document.createElementNS(NS, "svg");
    svg.setAttribute("viewBox", "0 0 " + W + " " + H);
    svg.setAttribute("width", "100%");
    svg.setAttribute("height", String(H));
    svg.setAttribute("role", "img");
    svg.setAttribute("aria-label", host.getAttribute("data-trend-label") || reportCopy(root).rating_trend);

    [5, 3, 1].forEach(function (level) {
      var line = document.createElementNS(NS, "line");
      line.setAttribute("class", "oi-trend-line-grid");
      line.setAttribute("x1", String(padL));
      line.setAttribute("x2", String(W - padR));
      line.setAttribute("y1", String(yFor(level)));
      line.setAttribute("y2", String(yFor(level)));
      svg.appendChild(line);
    });

    var points = trend.map(function (t, i) {
      return (padL + i * xStep) + "," + yFor(t.avg);
    }).join(" ");
    var poly = document.createElementNS(NS, "polyline");
    poly.setAttribute("class", "oi-trend-poly");
    poly.setAttribute("points", points);
    svg.appendChild(poly);

    trend.forEach(function (t, i) {
      var cx = padL + i * xStep;
      var dot = document.createElementNS(NS, "circle");
      dot.setAttribute("class", "oi-trend-dot");
      dot.setAttribute("cx", String(cx));
      dot.setAttribute("cy", String(yFor(t.avg)));
      dot.setAttribute("r", "3.5");
      svg.appendChild(dot);
      if (i % labelStep === 0 && t.month) {
        var label = document.createElementNS(NS, "text");
        label.setAttribute("class", "oi-trend-label");
        label.setAttribute("x", String(cx));
        label.setAttribute("y", String(H - 6));
        label.setAttribute("text-anchor", "middle");
        var month = /^(\d{4})-(0[1-9]|1[0-2])$/.exec(String(t.month));
        label.textContent = month ? new Date(Date.UTC(Number(month[1]), Number(month[2]) - 1, 1))
          .toLocaleDateString(root.dataset.locale, {month: "short", year: "2-digit", timeZone: "UTC"}) : String(t.month);
        svg.appendChild(label);
      }
    });

    clearNode(host);
    host.appendChild(svg);
  }

  function renderChips(host, items, modifier, emptyText, root) {
    if (!host) return;
    clearNode(host);
    var list = items && items.length ? items : null;
    if (!list) {
      var empty = document.createElement("span");
      empty.className = "oi-chip oi-chip--" + modifier;
      empty.textContent = emptyText;
      host.appendChild(empty);
      return;
    }
    list.forEach(function (k) {
      var chip = document.createElement("span");
      chip.className = "oi-chip oi-chip--" + modifier;
      chip.textContent = k.word + " · " + formatNumber(k.count, root);
      host.appendChild(chip);
    });
  }

  function renderList(host, items, emptyText) {
    if (!host) return;
    clearNode(host);
    var list = items && items.length ? items : (emptyText ? [emptyText] : []);
    list.forEach(function (entry) {
      var li = document.createElement("li");
      li.textContent = entry;
      host.appendChild(li);
    });
  }

  /**
   * Zieht vereinzelte Du-Formen aus den Server-Empfehlungen auf die Sie-Form
   * nach, damit die Seite durchgängig siezt. Die Regel bleibt bewusst bestehen,
   * auch nachdem die Analyse-Bibliothek serverseitig korrigiert wurde: Theme
   * und Cloud Function werden getrennt ausgerollt (Theme per Hand im Shopify-
   * Admin, Function per CI), sodass beide Stände zeitweise auseinanderlaufen
   * können — auch nach einem Backend-Rollback. Greift die Regel nicht, kostet
   * sie nichts. Siehe BACKEND-INTEGRATION.md.
   */
  var FORMAL_FIXES = [
    ["Antworte auf mehr Bewertungen", "Antworten Sie auf mehr Bewertungen"]
  ];

  function toFormalAddress(text) {
    var out = String(text == null ? "" : text);
    for (var i = 0; i < FORMAL_FIXES.length; i++) {
      out = out.split(FORMAL_FIXES[i][0]).join(FORMAL_FIXES[i][1]);
    }
    return out;
  }

  /**
   * Rendert ein Zitat. Der Autorenname wird bewusst nie ausgegeben — die API
   * liefert ihn aus Datenschutzgründen grundsätzlich nicht.
   */
  function renderQuote(host, quote, worst, emptyText, root) {
    if (!host) return;
    clearNode(host);
    var wrap = document.createElement("div");
    wrap.className = worst ? "oi-quote oi-quote--worst" : "oi-quote";
    var p = document.createElement("p");
    if (!quote || !quote.text) {
      p.textContent = emptyText;
      wrap.appendChild(p);
      host.appendChild(wrap);
      return;
    }
    p.textContent = "„" + quote.text + "\u201C";
    wrap.appendChild(p);

    var meta = document.createElement("div");
    meta.className = "oi-quote-meta";
    var rating = Number(quote.rating) || 0;
    var pct = Math.max(0, Math.min(100, Math.round(rating * 20)));
    var stars = document.createElement("span");
    stars.className = "oi-stars";
    stars.setAttribute("role", "img");
    stars.setAttribute("aria-label", formatNumber(rating, root) + " " + reportCopy(root).out_of_five);
    var bg = document.createElement("span");
    bg.className = "oi-stars__bg";
    bg.setAttribute("aria-hidden", "true");
    bg.textContent = "★★★★★";
    var fg = document.createElement("span");
    fg.className = "oi-stars__fg";
    fg.setAttribute("aria-hidden", "true");
    fg.style.width = pct + "%";
    fg.textContent = "★★★★★";
    stars.appendChild(bg);
    stars.appendChild(fg);
    meta.appendChild(stars);
    var quoteDate = formatDate(quote.date, root);
    if (quoteDate) {
      var date = document.createElement("span");
      date.innerHTML = "&nbsp;·&nbsp;";
      date.appendChild(document.createTextNode(quoteDate));
      meta.appendChild(date);
    }
    wrap.appendChild(meta);
    host.appendChild(wrap);
  }

  function applyReport(root, data) {
    var place = data.place || {};
    var report = data.report || {};
    var scores = report.scores || {};
    var sample = report.sample || {};
    var topicAnalysis = report.topicAnalysis || {};
    var topicsAvailable = topicAnalysis.version === 1 && topicAnalysis.method === "aspect_mentions" && topicAnalysis.status === "available";
    var keywords = topicsAvailable ? report.keywords || {} : {};
    var quotes = report.quotes || {};

    var dateNode = root.querySelector("[data-oi-analyzed]");
    var analysisDate = formatDate(data.createdAt, root);
    textOf(dateNode, analysisDate ? fillTemplate(root.dataset.analyzedPattern, { datum: analysisDate }) : "");
    if (dateNode) dateNode.hidden = !dateNode.textContent;
    textOf(root.querySelector("[data-oi-name]"), place.name || "");
    renderThumb(root, place.name || "", place.photo || "");
    renderMeta(root, place);

    var rating = scores.googleRating;
    textOf(root.querySelector("[data-oi-rating]"), rating == null ? "—" : formatNumber(rating, root, 1));
    var starHost = root.querySelector("[data-oi-starrow]");
    if (starHost) {
      clearNode(starHost);
      var wrap = document.createElement("span");
      wrap.className = "oi-stars";
      wrap.setAttribute("role", "img");
      wrap.setAttribute("aria-label", reportCopy(root).rating + " " + formatNumber(rating, root, 1) + " " + reportCopy(root).out_of_five);
      var inner = document.createElement("span");
      inner.setAttribute("aria-hidden", "true");
      inner.textContent = starRow(rating);
      wrap.appendChild(inner);
      starHost.appendChild(wrap);
    }
    textOf(root.querySelector("[data-oi-google-label]"),
      (root.dataset.googleLabel || "") + " (" + (Number(sample.totalOnGoogle) === 1 ? reportCopy(root).review_count_one : fillTemplate(reportCopy(root).review_count, {n: formatNumber(sample.totalOnGoogle, root)})) + ")");

    textOf(root.querySelector("[data-oi-last12]"), formatNumber(sample.count, root));
    textOf(root.querySelector("[data-oi-response]"), formatPercent(report.responseRate, root));
    var responseSample = report.responseSample || {};
    var responseCount = responseSample.count == null ? sample.count : responseSample.count;
    var copy = reportCopy(root);
    var responseNote = report.responseRate == null ? copy.response_unavailable :
      (responseSample.answered == null ? (responseCount == null ? copy.response_sample :
        fillTemplate(copy.response_count, {n: formatNumber(responseCount, root)})) :
        fillTemplate(copy.response_answered, {answered: formatNumber(responseSample.answered, root), n: formatNumber(responseCount, root)}));
    if (responseSample.from && responseSample.to) {
      responseNote += " " + formatDate(responseSample.from, root) + "–" + formatDate(responseSample.to, root) + ".";
    }
    textOf(root.querySelector("[data-oi-response-note]"), responseNote + " " + copy.response_not_total);

    renderDistribution(root, report.distribution);
    renderTrend(root, report.trend);
    var topicNotice = typeof topicAnalysis.notice === "string" ? topicAnalysis.notice.trim() : "";
    if (topicNotice === "Die Sterne beziehen sich auf die gesamte Rezension, nicht auf das einzelne Thema. Gezählt werden Nennungen bekannter Aspekte in Rezensionen mit 4–5 bzw. 1–2 Sternen; Rezensionen mit 3 Sternen sind nicht enthalten. Das ist keine Bewertung einzelner Aspekte." ||
        topicNotice === "Zählung: Rezensionen mit Themennennung. Sterne gelten für die ganze Rezension, nicht für einzelne Aspekte." ||
        topicNotice === "Themen aus 4–5- und 1–2-Sterne-Rezensionen. Sterne bewerten die ganze Rezension.") {
      topicNotice = root.dataset.topicNote;
    }
    textOf(root.querySelector("[data-oi-topic-note]"), topicNotice || (topicsAvailable ? root.dataset.topicNote : root.dataset.topicUnavailable));
    renderChips(root.querySelector("[data-oi-chips-pos]"), keywords.positive, "pos",
      topicsAvailable ? root.dataset.topicEmptyPositive : root.dataset.topicEmptyUnavailable, root);
    renderChips(root.querySelector("[data-oi-chips-neg]"), keywords.negative, "neg",
      topicsAvailable ? root.dataset.topicEmptyNegative : root.dataset.topicEmptyUnavailable, root);
    renderList(root.querySelector("[data-oi-strengths]"), topicsAvailable ? report.strengths : [],
      topicsAvailable ? root.dataset.topicEmptyRepeated : root.dataset.topicEmptyUnavailable);
    renderList(root.querySelector("[data-oi-weaknesses]"), topicsAvailable ? report.weaknesses : [],
      topicsAvailable ? root.dataset.topicEmptyRepeated : root.dataset.topicEmptyUnavailable);

    var recsCard = root.querySelector("[data-oi-recs-card]");
    var recs = (report.recommendations || []).filter(function (entry) {
      return topicsAvailable || typeof entry !== "string" || !entry.startsWith("Häufigstes Kritikthema ");
    }).map(toFormalAddress);
    if (recsCard) recsCard.hidden = !recs.length;
    renderList(root.querySelector("[data-oi-recs]"), recs, "");

    renderQuote(root.querySelector("[data-oi-best]"), quotes.best, false,
      reportCopy(root).quote_empty, root);
    renderQuote(root.querySelector("[data-oi-worst]"), quotes.worst, true,
      reportCopy(root).quote_critical_empty, root);
  }

  function reportUrlWithParam(url, key, value) {
    var hashAt = url.indexOf("#");
    var hash = hashAt === -1 ? "" : url.slice(hashAt);
    var beforeHash = hashAt === -1 ? url : url.slice(0, hashAt);
    return beforeHash + (beforeHash.indexOf("?") !== -1 ? "&" : "?") +
      encodeURIComponent(key) + "=" + encodeURIComponent(value) + hash;
  }

  function initReport(root) {
    if (root.dataset.oiReady === "true") return;
    root.dataset.oiReady = "true";

    var base = (root.dataset.apiBase || "").trim().replace(/\/+$/, "");
    var param = (root.dataset.slugParam || "slug").trim() || "slug";
    var slug = "";
    try {
      slug = new URLSearchParams(window.location.search).get(param) || "";
    } catch (err) {
      slug = "";
    }
    var returnTo = "";
    try {
      var rawReturn = new URLSearchParams(window.location.search).get("returnTo") || "";
      if (rawReturn.charAt(0) === "/" && rawReturn.slice(0, 2) !== "//") {
        var parsedReturn = new URL(rawReturn, window.location.href);
        if (parsedReturn.origin === new URL(window.location.href).origin) {
          ["company", "competitors", "benchmark", "search", "placeId", "returnTo"].forEach(function (key) {
            parsedReturn.searchParams.delete(key);
          });
          returnTo = parsedReturn.pathname + parsedReturn.search + parsedReturn.hash;
        }
      }
    } catch (err) { returnTo = ""; }
    var back = root.querySelector("[data-oi-back]");
    if (back && returnTo) back.href = localPageUrl(returnTo, root);
    var status = root.querySelector("[data-oi-status]");
    function setStatus(text, keepLoading, failed) {
      if (status) {
        if (text) { status.textContent = text; status.hidden = false; }
        else { status.hidden = true; }
      }
      root.classList.toggle("is-loading", !!keepLoading);
      root.setAttribute("aria-busy", keepLoading ? "true" : "false");
      root.classList.toggle("is-failed", !!failed);
    }

    if (!base && !slug && root.dataset.designMode === "true") {
      setStatus(reportCopy(root).design_preview, false);
      return;
    }
    if (!base || !slug) {
      setStatus(!base ? reportCopy(root).connection_missing : reportCopy(root).select_location, false, true);
      return;
    }
    var controller = new AbortController();
    var timeout;
    setStatus((root.dataset.loadingText == null ? reportCopy(root).loading : root.dataset.loadingText), true);

    var handoff = window.OptimizzerReportHandoff?.take(base, slug);
    var reportRequest = Promise.resolve(handoff).then(function (data) {
      if (data) return data;
      return requestHeaders(root).then(function (headers) {
      if (controller.signal.aborted) throw new Error("request_aborted");
      timeout = setTimeout(function () { controller.abort(); }, 15000);
      return fetch(base + "/api/analysis/" + encodeURIComponent(slug) + "?view=1", { credentials: "omit", headers: headers, signal: controller.signal });
    })
      .then(function (res) {
        if (res.status === 404) throw new Error("not_found");
        if (res.status === 429 || res.status === 503) throw new Error("global_limit");
        if (!res.ok) throw new Error("http_" + res.status);
        return res.json();
      });
    });
    reportRequest.then(function (data) {
        // Ein Benchmark-Slug gehört auf die Vergleichsseite — dorthin umleiten.
        if (data && data.kind === "multi") {
          var target = (root.dataset.benchmarkUrl || "").trim();
          if (target) {
            var redirect = reportUrlWithParam(target, param, slug);
            if (returnTo) redirect = reportUrlWithParam(redirect, "returnTo", returnTo);
            window.location.replace(redirect);
            return;
          }
          throw new Error("wrong_kind");
        }
        if (!data || data.kind !== "single" || !data.place || !data.report) throw new Error("invalid_report");
        applyReport(root, data);
        setStatus("", false);
        window.shoptimizerInsightsTracking?.reportViewed(root, "single", base + ":" + slug);
      })
      .catch(function (err) {
        var message = (root.dataset.errorText == null ? reportCopy(root).error : root.dataset.errorText);
        if (err && err.message === "not_found") {
          message = (root.dataset.notfoundText == null ? reportCopy(root).not_found : root.dataset.notfoundText);
        } else if (err && (err.message === "global_limit" || err.message === "rate_limited")) {
          message = reportCopy(root).unavailable;
        }
        if (err && err.name === "AbortError") message = reportCopy(root).timeout;
        setStatus(message, false, true);
      })
      .finally(function () { clearTimeout(timeout); });
  }

  function boot(scope) {
    (scope || document).querySelectorAll("[data-oi-report]").forEach(initReport);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insights-report-preview"] && !Shopify.designMode) return;
  try {
    
(function () {
  function requestHeaders(root) {
    var timer;
    var expired = false;
    var operation = Promise.resolve().then(function () {
      if (window.ShoptimizerAppCheck) return;
      if (!root.dataset.appCheckHelperUrl) throw new Error("app_check_configuration");
      return import(root.dataset.appCheckHelperUrl);
    }).then(function () {
      if (expired) throw new Error("app_check_timeout");
      return window.ShoptimizerAppCheck.getHeadersFromElement(root);
    });
    return Promise.race([operation, new Promise(function (_resolve, reject) {
      timer = setTimeout(function () { expired = true; reject(new Error("app_check_timeout")); }, 30000);
    })]).finally(function () { clearTimeout(timer); });
  }

  function returnTarget(raw) {
    var target = new URL(window.location.href);
    if (raw && raw.charAt(0) === "/" && raw.slice(0, 2) !== "//") {
      try {
        var configured = new URL(raw, target);
        if (configured.origin === target.origin) target = configured;
      } catch (err) { /* Use the current entry page for invalid configured targets. */ }
    }
    ["company", "competitors", "benchmark", "search", "placeId", "returnTo"].forEach(function (key) {
      target.searchParams.delete(key);
    });
    return target.pathname + target.search + target.hash;
  }

  var requests = window.oiFeaturedReportRequests || (window.oiFeaturedReportRequests = Object.create(null));
  async function init(root) {
    if (root.dataset.oiReady) return;
    root.dataset.oiReady = "true";
    var locale = root.dataset.locale;
    var base = (root.dataset.apiBase || "").trim().replace(/\/+$/, "");
    if (!base) return;
    function read(path) {
      var url = base + path;
      if (!requests[url]) {
        requests[url] = requestHeaders(root).then(function (headers) {
          return fetch(url, {credentials: "omit", headers: headers, signal: AbortSignal.timeout(15000)});
        }).then(function (res) {
          if (!res.ok) throw new Error("report_unavailable");
          return res.json();
        }).catch(function (err) { delete requests[url]; throw err; });
      }
      return requests[url];
    }
    function text(selector, value) { root.querySelector(selector).textContent = value; }
    function number(value) { return typeof value === "number" && Number.isFinite(value) && value >= 0; }
    try {
      var slug = (root.dataset.featuredSlug || "").trim();
      if (!slug) return;
      var data = await read("/api/analysis/" + encodeURIComponent(slug));
      if (data.kind !== "single" || !data.place || !data.report) throw new Error("single_report_required");
      var report = data.report;
      var rating = (report.scores || {}).googleRating;
      var count = (report.sample || {}).totalOnGoogle;
      text("[data-oi-featured-name]", data.place.name || root.dataset.locationAnalysis);
      text("[data-oi-featured-meta]", data.place.city || "");
      text("[data-oi-featured-rating]", number(rating) && rating <= 5 ? rating.toLocaleString(locale, {minimumFractionDigits: 1}) + " ★" : "—");
      text("[data-oi-featured-count]", number(count) ? (count === 1 ? root.dataset.reviewCountOne : root.dataset.reviewCountMany).replace("[n]", count.toLocaleString(locale)) : root.dataset.reviewCountUnavailable);
      var distribution = report.distribution || {};
      var distributionCount = [1, 2, 3, 4, 5].reduce(function (sum, star) { return sum + (number(distribution[star]) ? distribution[star] : 0); }, 0);
      var distributionCopy = distributionCount && distributionCount === count ? root.dataset.distributionAll
        : distributionCount && distributionCount === (report.sample || {}).count ? root.dataset.distributionSample : root.dataset.distributionUnavailable;
      var distributionNote = root.querySelector('[data-oi-featured-distribution-note]');
      if (distributionNote && distributionNote.dataset.defaultDistributionNote !== undefined) distributionNote.textContent = (distributionCopy || '').replace('[n]', distributionCount.toLocaleString(locale));
      var max = Math.max.apply(null, [1].concat(Object.values(distribution).filter(number)));
      var bars = root.querySelector("[data-oi-featured-distribution]");
      [5, 4, 3, 2, 1].forEach(function (star) {
        var value = distribution[star];
        var row = document.createElement("div"); row.className = "oi-rp__bar";
        var label = document.createElement("span"); label.textContent = star.toLocaleString(locale) + " ★";
        var track = document.createElement("span"); track.className = "oi-rp__track";
        var fill = document.createElement("span"); fill.className = "oi-rp__fill";
        fill.style.width = (number(value) ? value / max * 100 : 0) + "%";
        track.appendChild(fill);
        var total = document.createElement("span"); total.textContent = number(value) ? value.toLocaleString(locale) : "—";
        row.appendChild(label); row.appendChild(track); row.appendChild(total); bars.appendChild(row);
      });
      var url = new URL(root.dataset.reportUrl || "/pages/insights-report", window.location.href);
      if (!/^https?:$/.test(url.protocol)) throw new Error("invalid_report_link");
      var localeRoot = (root.dataset.localeRoot || "").replace(/\/+$/, "");
      if (url.origin === new URL(window.location.href).origin && /^\/pages(?:\/|$)/.test(url.pathname)) {
        url.pathname = localeRoot + url.pathname;
      }
      url.searchParams.set("slug", slug);
      url.searchParams.set("returnTo", returnTarget(url.searchParams.get("returnTo")));
      root.querySelector("[data-oi-featured-link]").href = url.href;
      root.querySelector("[data-oi-featured-content]").hidden = false;
      root.querySelector("[data-oi-featured-fallback]").hidden = true;
    } catch (err) {
      // Keep the configured image and static preview when the optional report is unavailable.
    }
  }
  function boot() { document.querySelectorAll("[data-oi-featured-report]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insights-stats-trust"] && !Shopify.designMode) return;
  try {
    
(function () {
  function requestHeaders(root) {
    var timer;
    var expired = false;
    var operation = Promise.resolve().then(function () {
      if (window.ShoptimizerAppCheck) return;
      if (!root.dataset.appCheckHelperUrl) throw new Error("app_check_configuration");
      return import(root.dataset.appCheckHelperUrl);
    }).then(function () {
      if (expired) throw new Error("app_check_timeout");
      return window.ShoptimizerAppCheck.getHeadersFromElement(root);
    });
    return Promise.race([operation, new Promise(function (_resolve, reject) {
      timer = setTimeout(function () { expired = true; reject(new Error("app_check_timeout")); }, 30000);
    })]).finally(function () { clearTimeout(timer); });
  }

  var requests = window.oiFeaturedReportRequests || (window.oiFeaturedReportRequests = Object.create(null));
  async function init(root) {
    if (root.dataset.oiReady) return;
    root.dataset.oiReady = "true";
    var status = root.querySelector("[data-oi-stats-status]");
    var locale = root.dataset.locale;
    var base = (root.dataset.apiBase || "").trim().replace(/\/+$/, "");
    if (!base) return;
    function read(path) {
      var url = base + path;
      if (!requests[url]) {
        requests[url] = requestHeaders(root).then(function (headers) {
          return fetch(url, {credentials: "omit", headers: headers, signal: AbortSignal.timeout(15000)});
        }).then(function (res) {
          if (!res.ok) throw new Error("report_unavailable");
          return res.json();
        }).catch(function (err) { delete requests[url]; throw err; });
      }
      return requests[url];
    }
    function value(key, amount, suffix, decimals, max) {
      var valid = typeof amount === "number" && Number.isFinite(amount) && amount >= 0 && (max == null || amount <= max);
      root.querySelector('[data-oi-stat="' + key + '"]').textContent = valid ? amount.toLocaleString(locale, {minimumFractionDigits: decimals || 0, maximumFractionDigits: decimals || 0}) + (suffix || "") : "—";
    }
    try {
      var slug = (root.dataset.featuredSlug || "").trim();
      if (!slug) return;
      var data = await read("/api/analysis/" + encodeURIComponent(slug));
      if (data.kind !== "single" || !data.place || !data.report) throw new Error("single_report_required");
      var report = data.report;
      var sample = report.sample || {};
      value("rating", (report.scores || {}).googleRating, " ★", 1, 5);
      value("total", sample.totalOnGoogle);
      value("sample", sample.count);
      var date = new Date(data.createdAt || "");
      status.textContent = [data.place.name, data.place.city, Number.isNaN(date.getTime()) ? "" : root.dataset.analyzedOn.replace("[date]", date.toLocaleDateString(locale))].filter(Boolean).join(" · ");
      root.querySelector("[data-oi-stats-grid]").hidden = false;
      root.hidden = false;
    } catch (err) {
      // Optional marketing statistics stay hidden when the report is unavailable.
    }
  }
  function boot() { document.querySelectorAll("[data-oi-live-stats]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", boot);
})();

  } catch(e) { console.error(e); }
})();
})();
